// Comprehensive product data for NutraFuel Supplements

export const productsData = [
  {
    id: 1,
    slug: 'on-gold-standard-whey',
    name: 'ON Gold Standard 100% Whey',
    category: 'whey',
    brand: 'Optimum Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/nvusgy8j_IMG_2501.jpeg',
    description: '24g protein per serving, premium whey isolate blend',
    longDescription: 'Gold Standard 100% Whey by Optimum Nutrition is the world\'s best-selling whey protein powder. Each serving delivers 24g of high-quality whey protein primarily from whey protein isolate, which has had excess carbohydrates, fat, and lactose removed. This premium formula also provides naturally occurring BCAAs and glutamine to support muscle recovery and growth after intense workouts.',
    features: ['24g Protein', '5.5g BCAAs', 'Fast Absorbing'],
    popular: true,
    price: 4999,
    stock: 'In Stock',
    protein: '24g',
    calories: 120,
    servings: 28,
    sizes: ['1kg', '2kg', '5kg'],
    flavors: ['Double Rich Chocolate', 'Vanilla', 'Cookies & Cream'],
    benefits: ['Builds lean muscle mass', 'Fast post-workout absorption', 'Supports muscle recovery', 'Low in fat and carbs', 'Mixes easily with water or milk'],
    bestFor: 'Muscle gain & recovery',
    ingredients: 'Whey Protein Isolate, Whey Protein Concentrate, Whey Peptides, Cocoa (Processed with Alkali), Natural & Artificial Flavors, Lecithin, Acesulfame Potassium, Aminogen, Lactase',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (30.4g)' },
      { label: 'Calories', value: '120' },
      { label: 'Total Fat', value: '1.5g' },
      { label: 'Cholesterol', value: '30mg' },
      { label: 'Sodium', value: '60mg' },
      { label: 'Total Carbohydrate', value: '3g' },
      { label: 'Sugars', value: '1g' },
      { label: 'Protein', value: '24g' },
      { label: 'BCAAs', value: '5.5g' },
      { label: 'Glutamine & Glutamic Acid', value: '4g' },
    ],
  },
  {
    id: 2,
    slug: 'mb-biozyme-performance-whey',
    name: 'MB Biozyme Performance Whey',
    category: 'whey',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/46de3r41_IMG_2495.jpeg',
    description: '25g protein, USA sourced whey with digestive enzymes',
    longDescription: 'MuscleBlaze Biozyme Performance Whey is India\'s first protein with Enhanced Absorption Formula (EAF). It provides 25g protein per serving with added DigeZyme multi-enzyme complex for better protein absorption. The USA-sourced whey ensures premium quality, while the low carb and fat content makes it perfect for lean muscle building.',
    features: ['25g Protein', 'Digestive Enzymes', 'Low Carb'],
    popular: true,
    price: 3499,
    stock: 'In Stock',
    protein: '25g',
    calories: 115,
    servings: 30,
    sizes: ['1kg', '2kg'],
    flavors: ['Rich Chocolate', 'Caf\u00e9 Mocha', 'Cookies & Cream'],
    benefits: ['Enhanced protein absorption with DigeZyme', 'Supports lean muscle mass', 'USA sourced premium whey', 'Low in carbs and fat', 'Reduces bloating and discomfort'],
    bestFor: 'Lean muscle & digestive health',
    ingredients: 'Whey Protein Concentrate, Whey Protein Isolate, Cocoa Powder, DigeZyme (Multi-Enzyme Complex), Natural & Artificial Flavors, Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (32g)' },
      { label: 'Calories', value: '115' },
      { label: 'Total Fat', value: '1g' },
      { label: 'Cholesterol', value: '25mg' },
      { label: 'Sodium', value: '55mg' },
      { label: 'Total Carbohydrate', value: '2.5g' },
      { label: 'Sugars', value: '1g' },
      { label: 'Protein', value: '25g' },
      { label: 'BCAAs', value: '5.51g' },
      { label: 'DigeZyme', value: '75mg' },
    ],
  },
  {
    id: 3,
    slug: 'c4-pre-workout-60s',
    name: 'C4 Pre-Workout 60s',
    category: 'preworkout',
    brand: 'Cellucor',
    image: 'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/iejw8m1j_IMG_2496.jpeg',
    description: 'Explosive energy, focus, and pumps',
    longDescription: 'Cellucor C4 Original is America\'s #1 selling pre-workout brand. Formulated with CarnoSyn Beta-Alanine and caffeine, C4 delivers explosive energy, heightened focus, and an overwhelming urge to push through your toughest workouts. With 60 servings per container, it\'s built for athletes who train hard and train often.',
    features: ['150mg Caffeine', 'Beta Alanine', 'CarnoSyn'],
    popular: true,
    price: 2999,
    stock: 'Limited Stock',
    protein: '0g',
    calories: 5,
    servings: 60,
    sizes: ['60 servings', '30 servings'],
    flavors: ['Fruit Punch', 'Orange Burst', 'Icy Blue Razz'],
    benefits: ['Explosive energy for intense workouts', 'Enhanced mental focus and alertness', 'Skin-splitting muscle pumps', 'Delays muscle fatigue with Beta-Alanine', 'Trusted by athletes worldwide'],
    bestFor: 'Pre-workout energy & performance',
    ingredients: 'CarnoSyn Beta-Alanine (1.6g), Creatine Nitrate (1g), Arginine AKG (1g), Caffeine Anhydrous (150mg), N-Acetyl L-Tyrosine, Vitamin C, Niacin, Vitamin B6, Folic Acid, Vitamin B12',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (6.5g)' },
      { label: 'Calories', value: '5' },
      { label: 'Total Carbohydrate', value: '1g' },
      { label: 'Vitamin C', value: '250mg' },
      { label: 'Niacin', value: '30mg' },
      { label: 'Vitamin B6', value: '500mcg' },
      { label: 'Folic Acid', value: '250mcg' },
      { label: 'Vitamin B12', value: '35mcg' },
      { label: 'CarnoSyn Beta-Alanine', value: '1.6g' },
      { label: 'Caffeine Anhydrous', value: '150mg' },
    ],
  },
  {
    id: 4,
    slug: 'wellversed-creatine-kiwi-kick',
    name: 'Wellversed Micronised Creatine Monohydrate - Kiwi Kick',
    category: 'creatine',
    brand: 'Wellversed',
    image: 'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/s0bxrd6v_IMG_2498.jpeg',
    description: '3g micronised creatine monohydrate per serving - Boosts ATP production, zero side effects, Kiwi Kick flavour, 122g',
    longDescription: 'Wellversed Wellcore Micronised Creatine Monohydrate is the ultimate fuel for muscle growth. Each serving delivers 3g of micronised creatine monohydrate that boosts ATP production for explosive strength and power during high-intensity training. The micronised formula ensures superior solubility and faster absorption with zero grittiness. With zero side effects and a refreshing Kiwi Kick flavour, this creatine supplement makes daily supplementation enjoyable. Tested, certified, and lab accredited for quality assurance. 33 servings per container in a convenient 122g tub.',
    features: ['3g Creatine', 'Boosts ATP', 'Zero Side Effects'],
    popular: true,
    price: 1299,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 33,
    sizes: ['122g (4.30oz)'],
    flavors: ['Kiwi Kick'],
    benefits: ['Boosts ATP production for explosive power', 'The ultimate fuel for muscle growth', 'Micronised for superior solubility and absorption', 'Zero side effects', 'Tested, certified and lab accredited'],
    bestFor: 'Strength & muscle growth',
    ingredients: 'Creatine Monohydrate (Micronised), Citric Acid, Natural Kiwi Flavoring, Sucralose, Silicon Dioxide',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (3.7g)' },
      { label: 'Creatine Monohydrate', value: '3g' },
      { label: 'Calories', value: '0' },
      { label: 'Servings Per Container', value: '33' },
    ],
  },
  {
    id: 5,
    slug: 'muscletech-multivitamin',
    name: 'MuscleTech Multivitamin',
    category: 'vitamins',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/u6w20s4n_IMG_2499.jpeg',
    description: 'Complete daily nutrition for active individuals',
    longDescription: 'MuscleTech Platinum Multivitamin is engineered for active individuals who demand more from their daily vitamin. With over 20 essential vitamins and minerals, amino acids, and herbal extracts, this comprehensive formula supports energy production, immune function, and overall health to keep you performing at your peak.',
    features: ['20+ Vitamins', 'Amino Acids', 'Energy Support'],
    popular: true,
    price: 1799,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 90,
    sizes: ['90 tablets', '180 tablets'],
    flavors: ['N/A'],
    benefits: ['Complete daily nutrition for athletes', 'Supports energy production and metabolism', 'Strengthens immune system', 'Contains amino acids for recovery', 'Herbal extracts for overall wellness'],
    bestFor: 'Overall health & wellness',
    ingredients: 'Vitamin A, Vitamin C, Vitamin D3, Vitamin E, Vitamin K, Thiamin, Riboflavin, Niacin, Vitamin B6, Folic Acid, Vitamin B12, Biotin, Pantothenic Acid, Calcium, Iron, Magnesium, Zinc, Selenium, Copper, Manganese, Chromium, L-Glutamine, Green Tea Extract',
    supplementFacts: [
      { label: 'Serving Size', value: '3 Tablets' },
      { label: 'Vitamin A', value: '3500 IU' },
      { label: 'Vitamin C', value: '250mg' },
      { label: 'Vitamin D3', value: '800 IU' },
      { label: 'Vitamin E', value: '60 IU' },
      { label: 'Vitamin B6', value: '15mg' },
      { label: 'Vitamin B12', value: '100mcg' },
      { label: 'Zinc', value: '15mg' },
      { label: 'L-Glutamine', value: '75mg' },
      { label: 'Green Tea Extract', value: '50mg' },
    ],
  },
  {
    id: 6,
    slug: 'labrada-super-mass-gainer',
    name: 'Labrada Super Mass Gainer',
    category: 'massgainer',
    brand: 'Labrada',
    image: 'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/pjs1m2hd_IMG_2500.jpeg',
    description: 'High calorie formula for serious mass gains',
    longDescription: 'Labrada Muscle Mass Gainer is a high-calorie bodybuilding shake designed for hard gainers who struggle to put on weight. Each serving delivers a massive 1,250 calories and 50g of protein along with creatine monohydrate and essential vitamins. This powerful formula provides the caloric surplus needed to fuel serious muscle growth and weight gain.',
    features: ['1250 Calories', '50g Protein', 'Creatine Added'],
    popular: true,
    price: 5499,
    stock: 'In Stock',
    protein: '50g',
    calories: 1250,
    servings: 16,
    sizes: ['6lb', '12lb'],
    flavors: ['Chocolate', 'Vanilla'],
    benefits: ['Massive 1,250 calories per serving', '50g high-quality protein for growth', 'Added creatine for strength gains', 'Essential vitamins and minerals included', 'Perfect for hard gainers and bulking phase'],
    bestFor: 'Mass gain & bulking',
    ingredients: 'Maltodextrin, Whey Protein Concentrate, Milk Protein Concentrate, Cocoa Powder, Creatine Monohydrate, Medium Chain Triglycerides, Vitamin & Mineral Blend, Natural & Artificial Flavors, Sucralose',
    supplementFacts: [
      { label: 'Serving Size', value: '4 Scoops (167g)' },
      { label: 'Calories', value: '1250' },
      { label: 'Total Fat', value: '8g' },
      { label: 'Total Carbohydrate', value: '222g' },
      { label: 'Sugars', value: '18g' },
      { label: 'Protein', value: '50g' },
      { label: 'Creatine Monohydrate', value: '3g' },
      { label: 'BCAAs', value: '10g' },
      { label: 'Calcium', value: '500mg' },
      { label: 'Iron', value: '6mg' },
    ],
  },
  {
    id: 8,
    slug: 'stainless-steel-premium-shaker',
    name: 'Stainless Steel Premium Shaker',
    category: 'accessories',
    brand: 'NutraFuel',
    image: 'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/2sd7h3h2_IMG_2446.jpeg',
    description: 'Premium stainless steel shaker bottle',
    longDescription: 'The NutraFuel Premium Stainless Steel Shaker is built for athletes who demand quality in everything they use. Made from food-grade 304 stainless steel, this shaker is durable, hygienic, and BPA-free. The leak-proof lid and built-in mixing ball ensure smooth, lump-free shakes every time. A gym bag essential.',
    features: ['Stainless Steel', 'Leak-Proof', 'BPA Free'],
    popular: true,
    price: 799,
    stock: 'In Stock',
    protein: 'N/A',
    calories: 'N/A',
    servings: 'N/A',
    sizes: ['700ml'],
    flavors: ['Silver', 'Black'],
    benefits: ['Food-grade 304 stainless steel', 'Completely leak-proof design', '100% BPA-free and non-toxic', 'Built-in mixing ball for smooth shakes', 'Durable and easy to clean'],
    bestFor: 'Daily use',
    ingredients: 'N/A',
    supplementFacts: [],
  },
  {
    id: 9,
    slug: 'carlyle-superfoods-multi-probiotics',
    name: 'Carlyle Superfoods Multi with Probiotics',
    category: 'vitamins',
    brand: 'Carlyle',
    image: 'https://customer-assets.emergentagent.com/job_musclefix-hub/artifacts/dck46739_IMG_3419.png',
    description: 'Complete multivitamin with probiotics, 20+ fruits & vegetables',
    longDescription: 'Carlyle Superfoods Multi with Probiotics combines the power of 20+ fruits and vegetables with a potent probiotic blend for comprehensive daily nutrition. This advanced formula delivers essential vitamins, minerals, and vitalizing antioxidants while supporting gut health with beneficial probiotics. Perfect for anyone looking to bridge nutritional gaps naturally.',
    features: ['Probiotics', '20+ Fruits & Veggies', 'Vitalizing Antioxidants'],
    popular: true,
    price: 1999,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 120,
    sizes: ['120 caplets'],
    flavors: ['N/A'],
    benefits: ['Complete daily nutrition from whole foods', 'Probiotic blend for gut health', 'Rich in antioxidants for immunity', '20+ fruits and vegetable extracts', 'Supports overall wellness and vitality'],
    bestFor: 'Overall health & immunity',
    ingredients: 'Vitamin A, Vitamin C, Vitamin D3, Vitamin E, Vitamin B Complex, Zinc, Selenium, Organic Spirulina, Organic Barley Grass, Acai Berry, Blueberry, Pomegranate, Cranberry, Broccoli, Spinach, Kale, Carrot, Beet Root, Probiotic Blend (Lactobacillus Acidophilus, Bifidobacterium Lactis)',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Caplets' },
      { label: 'Vitamin A', value: '2500 IU' },
      { label: 'Vitamin C', value: '200mg' },
      { label: 'Vitamin D3', value: '1000 IU' },
      { label: 'Vitamin E', value: '30 IU' },
      { label: 'Vitamin B12', value: '50mcg' },
      { label: 'Zinc', value: '11mg' },
      { label: 'Probiotic Blend', value: '100 Million CFU' },
      { label: 'Superfood Blend', value: '500mg' },
    ],
  },
  {
    id: 10,
    slug: 'now-omega-3-fish-oil-100',
    name: 'NOW Omega-3 Fish Oil 100 Softgels',
    category: 'vitamins',
    brand: 'NOW Foods',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/6v5tl1j8_IMG_5430.jpeg',
    description: 'Molecularly distilled fish oil with 180mg EPA & 120mg DHA for cardiovascular support',
    longDescription: 'NOW Omega-3 Fish Oil delivers 1,000mg of molecularly distilled fish oil per softgel, providing 180mg of EPA and 120mg of DHA. Molecular distillation ensures maximum purity by removing heavy metals, PCBs, and other contaminants. EPA and DHA are essential omega-3 fatty acids that support cardiovascular health, brain function, and reduce inflammation throughout the body. This Non-GMO formula is a must-have for athletes and active individuals looking to support overall health and recovery.',
    features: ['1000mg Fish Oil', '180mg EPA / 120mg DHA', 'Molecularly Distilled'],
    popular: true,
    price: 1499,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 100,
    sizes: ['100 softgels'],
    flavors: ['N/A'],
    benefits: ['Supports cardiovascular health', 'Enhances brain function and focus', 'Reduces inflammation and supports recovery', 'Molecularly distilled for maximum purity', 'Non-GMO certified'],
    bestFor: 'Heart & brain health',
    ingredients: 'Fish Oil Concentrate (from Anchovy, Sardine, Mackerel), EPA (Eicosapentaenoic Acid), DHA (Docosahexaenoic Acid), Gelatin, Glycerin, Water, Natural Lemon Flavor, Mixed Tocopherols',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Softgel' },
      { label: 'Fish Oil Concentrate', value: '1000mg' },
      { label: 'EPA', value: '180mg' },
      { label: 'DHA', value: '120mg' },
      { label: 'Total Omega-3', value: '300mg' },
    ],
  },
  {
    id: 11,
    slug: 'now-methyl-b12-5000mcg',
    name: 'NOW Methyl B-12 5,000 mcg',
    category: 'vitamins',
    brand: 'NOW Foods',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/tgtfitxo_IMG_5429.jpeg',
    description: 'High-potency methylcobalamin B-12 with folate for nervous system health & energy production',
    longDescription: 'NOW Methyl B-12 provides 5,000mcg of methylcobalamin, the most bioavailable and active form of Vitamin B-12. Unlike cheaper cyanocobalamin forms, methylcobalamin is immediately usable by your body without conversion. This high-potency formula supports nervous system health, energy production, and red blood cell formation. Fortified with folate for enhanced effectiveness. Especially beneficial for vegetarians and vegans who are at higher risk of B-12 deficiency. Available as easy-to-take lozenges that dissolve in the mouth for optimal sublingual absorption.',
    features: ['5000mcg B-12', 'Methylcobalamin', 'Vegan Friendly'],
    popular: true,
    price: 1299,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 60,
    sizes: ['60 lozenges'],
    flavors: ['N/A'],
    benefits: ['Supports nervous system health', 'Essential for energy production', 'Most bioavailable form of B-12 (methylcobalamin)', 'Includes folate for enhanced absorption', 'Ideal for vegetarians and vegans'],
    bestFor: 'Energy & nervous system health',
    ingredients: 'Methylcobalamin (Vitamin B-12), Folate (as Folic Acid), Xylitol, Cellulose, Stearic Acid, Natural Flavor, Citric Acid, Magnesium Stearate, Silica',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Lozenge' },
      { label: 'Vitamin B-12 (Methylcobalamin)', value: '5,000mcg' },
      { label: 'Folate (as Folic Acid)', value: '400mcg' },
    ],
  },
  {
    id: 12,
    slug: 'now-energy-metabolic-support',
    name: 'NOW Energy Metabolic & Adrenal Support',
    category: 'vitamins',
    brand: 'NOW Foods',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/332wjqnj_IMG_5428.jpeg',
    description: 'Natural energy boost with B-vitamins, green tea extract & adaptogenic herbs for sustained vitality',
    longDescription: 'NOW Energy is a comprehensive metabolic energy and adrenal support formula combining B-vitamins, green tea extract, and adaptogenic herbs. Unlike caffeine-heavy energy supplements that cause crashes, this formula supports your body\'s natural energy production pathways through metabolic optimization and adrenal health. The blend of vitamins, minerals, and herbal extracts provides sustained, clean energy throughout the day. Non-GMO and Vegetarian/Vegan certified, it is designed for athletes and active individuals who want long-lasting energy without jitters.',
    features: ['Energy Boost', 'Adrenal Support', 'Non-GMO / Vegan'],
    popular: true,
    price: 1699,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 90,
    sizes: ['90 veg capsules'],
    flavors: ['N/A'],
    benefits: ['Boosts metabolic energy production', 'Supports adrenal gland function', 'Sustained energy without crashes', 'Contains B-vitamins and adaptogenic herbs', 'Non-GMO and Vegan certified'],
    bestFor: 'Daily energy & vitality',
    ingredients: 'Vitamin B1 (Thiamine), Vitamin B2 (Riboflavin), Vitamin B3 (Niacin), Vitamin B6, Vitamin B12, Pantothenic Acid, Green Tea Extract, Rhodiola Rosea Extract, Panax Ginseng, Eleuthero Root, Ashwagandha Extract, Vegetable Cellulose Capsule',
    supplementFacts: [
      { label: 'Serving Size', value: '3 Veg Capsules' },
      { label: 'Vitamin B1', value: '12.5mg' },
      { label: 'Vitamin B2', value: '12.5mg' },
      { label: 'Vitamin B6', value: '12.5mg' },
      { label: 'Vitamin B12', value: '500mcg' },
      { label: 'Green Tea Extract', value: '200mg' },
      { label: 'Panax Ginseng', value: '100mg' },
    ],
  },
  {
    id: 13,
    slug: 'now-d3-k2-chewables',
    name: 'NOW D3 + K2 Chewables',
    category: 'vitamins',
    brand: 'NOW Foods',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/cb4xdepy_IMG_5427.jpeg',
    description: '5,000 IU Vitamin D3 + 90mcg K2 (MenaQ7) for bone, cardiovascular & immune support',
    longDescription: 'NOW D3 + K2 combines 5,000 IU of Vitamin D3 with 90mcg of Vitamin K2 (as MenaQ7, a clinically studied and highly bioavailable form) in convenient chewable tablets. Vitamin D3 promotes calcium absorption and supports immune function, while Vitamin K2 directs calcium to your bones and teeth, keeping it out of your arteries. This synergistic combination is essential for bone density, cardiovascular health, and a strong immune system. Non-GMO certified with 90 chewable tablets per bottle.',
    features: ['5000 IU D3', '90mcg K2 MenaQ7', 'Bone & Immune'],
    popular: true,
    price: 1599,
    stock: 'In Stock',
    protein: '0g',
    calories: 5,
    servings: 90,
    sizes: ['90 chewable tablets'],
    flavors: ['N/A'],
    benefits: ['Supports strong bones and teeth', 'Promotes cardiovascular health', 'Boosts immune system function', 'MenaQ7 K2 for optimal calcium utilization', 'Non-GMO certified'],
    bestFor: 'Bone health & immunity',
    ingredients: 'Vitamin D3 (as Cholecalciferol), Vitamin K2 (as MenaQ7 Menaquinone-7), Xylitol, Cellulose, Stearic Acid, Natural Mint Flavor, Magnesium Stearate, Silica',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Chewable Tablet' },
      { label: 'Vitamin D3', value: '5,000 IU (125mcg)' },
      { label: 'Vitamin K2 (MenaQ7)', value: '90mcg' },
    ],
  },
  {
    id: 14,
    slug: 'now-collagen-peptides-powder',
    name: 'NOW Collagen Peptides Powder',
    category: 'vitamins',
    brand: 'NOW Foods',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/ekoyuvws_IMG_5426.jpeg',
    description: 'Clinically tested collagen peptides for joint, bone & skin health - 227g powder',
    longDescription: 'NOW Collagen Peptides Powder is a clinically tested dietary supplement that provides hydrolyzed collagen peptides for comprehensive joint, bone, and skin health support. Collagen is the most abundant protein in your body, forming the structural foundation of skin, joints, bones, and connective tissue. As we age, collagen production decreases, leading to joint stiffness, wrinkles, and weakened bones. This Non-GMO, easily mixable powder delivers bioavailable collagen peptides that your body can absorb and use efficiently. Simply mix into water, smoothies, or your protein shake.',
    features: ['Clinically Tested', 'Joint & Bone Health', 'Skin Support'],
    popular: true,
    price: 2299,
    stock: 'In Stock',
    protein: '10g',
    calories: 40,
    servings: 20,
    sizes: ['8 oz (227g)'],
    flavors: ['Unflavored'],
    benefits: ['Supports joint health and mobility', 'Strengthens bones and connective tissue', 'Promotes healthy, youthful skin', 'Clinically tested for effectiveness', 'Non-GMO, easily mixable powder'],
    bestFor: 'Joint, bone & skin health',
    ingredients: 'Hydrolyzed Bovine Collagen Peptides (Type I & III)',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Scoops (11g)' },
      { label: 'Calories', value: '40' },
      { label: 'Protein', value: '10g' },
      { label: 'Sodium', value: '45mg' },
      { label: 'Collagen Peptides', value: '10g' },
    ],
  },
  {
    id: 15,
    slug: 'now-biocell-collagen-type-ii',
    name: 'NOW BioCell Collagen Hydrolyzed Type II',
    category: 'vitamins',
    brand: 'NOW Foods',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/0tixmfub_IMG_5425.jpeg',
    description: 'Clinically validated hydrolyzed Type II collagen for joint mobility, comfort & healthy skin',
    longDescription: 'NOW BioCell Collagen features clinically validated hydrolyzed Type II collagen sourced from chicken cartilage. This advanced formula supports joint mobility and comfort while promoting healthy, youthful skin. BioCell Collagen is a patented matrix of hydrolyzed collagen Type II, chondroitin sulfate, and hyaluronic acid that works synergistically to support connective tissue health. Non-GMO certified with 120 capsules per bottle, it is ideal for athletes and active individuals looking to protect their joints and maintain skin elasticity.',
    features: ['BioCell Collagen', 'Joint & Skin Support', 'Clinically Validated'],
    popular: true,
    price: 2499,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 120,
    sizes: ['120 capsules'],
    flavors: ['N/A'],
    benefits: ['Enhances joint mobility and comfort', 'Promotes healthy, youthful skin', 'Clinically validated BioCell Collagen matrix', 'Contains chondroitin sulfate and hyaluronic acid', 'Non-GMO certified'],
    bestFor: 'Joint health & skin support',
    ingredients: 'BioCell Collagen Matrix (Chicken Cartilage Type II Collagen, Chondroitin Sulfate, Hyaluronic Acid), Cellulose Capsule, Magnesium Stearate, Silica',
    supplementFacts: [
      { label: 'Serving Size', value: '4 Capsules' },
      { label: 'BioCell Collagen Matrix', value: '2000mg' },
      { label: 'Type II Collagen', value: '1200mg' },
      { label: 'Chondroitin Sulfate', value: '400mg' },
      { label: 'Hyaluronic Acid', value: '200mg' },
    ],
  },
  {
    id: 17,
    slug: 'naturewise-liquid-collagen-renewal',
    name: 'NatureWise Liquid Collagen Renewal',
    category: 'vitamins',
    brand: 'NatureWise',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/gfgvcutl_IMG_5423.jpeg',
    description: 'Mixed berry liquid collagen with 4,000mg collagen, 2,000mcg biotin & Vitamin B complex',
    longDescription: 'NatureWise Liquid Collagen Renewal is a delicious mixed berry flavoured liquid supplement that delivers 4,000mg of hydrolyzed collagen (Type I and III), 2,000mcg of biotin, and a full Vitamin B complex in convenient single-serve liquid tubes. Simply tear, drink, and go. The liquid format ensures rapid absorption compared to pills and powders. This antioxidant-rich formula supports skin elasticity, hair strength, and nail health from within. Gluten-free and soy-free with 30 liquid tubes per box - one tube per day for a full month of renewal.',
    features: ['4000mg Collagen', '2000mcg Biotin', 'Liquid Tubes'],
    popular: true,
    price: 2799,
    stock: 'In Stock',
    protein: '0g',
    calories: 15,
    servings: 30,
    sizes: ['30 liquid tubes (300ml)'],
    flavors: ['Mixed Berry'],
    benefits: ['4,000mg hydrolyzed collagen Type I & III', '2,000mcg biotin for hair and nails', 'Rapid absorption liquid format', 'Antioxidant blend with Vitamin B complex', 'Gluten-free and soy-free'],
    bestFor: 'Skin, hair & nail renewal',
    ingredients: 'Hydrolyzed Collagen Peptides (Type I & III), Biotin, Vitamin B1 (Thiamine), Vitamin B3 (Niacin), Vitamin B6, Vitamin B9 (Folate), Vitamin B12, Purified Water, Natural Mixed Berry Flavor, Citric Acid, Stevia',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Liquid Tube (10ml)' },
      { label: 'Hydrolyzed Collagen', value: '4,000mg' },
      { label: 'Biotin', value: '2,000mcg' },
      { label: 'Vitamin B12', value: '6mcg' },
      { label: 'Vitamin B6', value: '2mg' },
      { label: 'Niacin', value: '16mg' },
    ],
  },
  {
    id: 18,
    slug: 'nature-made-zinc-30mg',
    name: 'Nature Made Zinc 30mg',
    category: 'vitamins',
    brand: 'Nature Made',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/owkynqzv_IMG_5422.jpeg',
    description: 'USP verified zinc 30mg tablets - essential nutrient, antioxidant & immune system support',
    longDescription: 'Nature Made Zinc 30mg is a pharmacist-recommended, USP verified dietary supplement providing 30mg of zinc per tablet. Zinc is an essential mineral that plays a critical role in immune system function, protein synthesis, wound healing, and DNA synthesis. As an antioxidant, it helps protect cells from oxidative damage. This is especially important for athletes whose intense training increases oxidative stress and zinc depletion through sweat. USP verification ensures the product meets strict standards for purity, potency, and quality. 100 tablets per bottle.',
    features: ['30mg Zinc', 'USP Verified', 'Immune Support'],
    popular: true,
    price: 899,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 100,
    sizes: ['100 tablets'],
    flavors: ['N/A'],
    benefits: ['Supports healthy immune system function', 'Essential nutrient and antioxidant', 'USP verified for purity and potency', 'Pharmacist recommended brand', 'Supports protein synthesis and recovery'],
    bestFor: 'Immune health & recovery',
    ingredients: 'Zinc (as Zinc Gluconate), Cellulose Gel, Stearic Acid, Croscarmellose Sodium, Magnesium Stearate, Hydroxypropyl Methylcellulose',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Tablet' },
      { label: 'Zinc (as Zinc Gluconate)', value: '30mg' },
    ],
  },
  {
    id: 19,
    slug: 'natures-bounty-hair-skin-nails',
    name: 'Nature\'s Bounty Hair, Skin & Nails',
    category: 'vitamins',
    brand: 'Nature\'s Bounty',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/cly9t2x2_IMG_5421.jpeg',
    description: 'Extra strength formula with 5,000mcg biotin, argan oil, vitamins C & E + hyaluronic acid',
    longDescription: 'Nature\'s Bounty Optimal Solutions Extra Strength Hair, Skin & Nails is the #1 brand for hair, skin, and nail support. This advanced formula delivers 5,000mcg of biotin per serving along with argan oil, antioxidant vitamins C and E, and hyaluronic acid in rapid-release liquid softgels for maximum absorption. Biotin is essential for keratin production, which forms the structural foundation of hair and nails. Argan oil provides nourishing fatty acids, while hyaluronic acid supports skin hydration and elasticity. 150 liquid softgels per bottle.',
    features: ['5000mcg Biotin', 'Argan Oil Infused', '150 Softgels'],
    popular: true,
    price: 2199,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 150,
    sizes: ['150 liquid softgels'],
    flavors: ['N/A'],
    benefits: ['5,000mcg biotin for strong hair and nails', 'Argan oil for nourishing fatty acids', 'Antioxidant vitamins C & E for skin protection', 'Hyaluronic acid for skin hydration', 'Rapid-release liquid softgels for fast absorption'],
    bestFor: 'Hair, skin & nail health',
    ingredients: 'Biotin, Vitamin A, Vitamin C, Vitamin D, Vitamin E, Thiamin, Riboflavin, Niacin, Vitamin B6, Folate, Vitamin B12, Argan Oil, Hyaluronic Acid, Glycerin, Soy Lecithin, Choline Bitartrate',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Liquid Softgels' },
      { label: 'Biotin', value: '5,000mcg' },
      { label: 'Vitamin C', value: '60mg' },
      { label: 'Vitamin E', value: '15mg' },
      { label: 'Vitamin A', value: '600mcg' },
      { label: 'Argan Oil', value: '16mg' },
      { label: 'Hyaluronic Acid', value: '2mg' },
    ],
  },
  {
    id: 20,
    slug: '4well-magnesium-mood-harmony',
    name: '4Well Mood Harmony Complex Magnesium',
    category: 'vitamins',
    brand: '4Well',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/n0hsjcwe_4Well%20Magnesium.jpg',
    description: '4-in-1 magnesium complex with 5-HTP & Vitamin B6 for restful sleep and mood support',
    longDescription: '4Well Mood Harmony Complex Magnesium is a premium 4-in-1 magnesium formula delivering 1800mg of magnesium blend (610mg active per serving) combined with 5-HTP and Vitamin B6. This powerful combination supports restful sleep, calms the nervous system, and promotes mood balance. 5-HTP is a natural precursor to serotonin, while Vitamin B6 enhances magnesium absorption for maximum effectiveness. Third-party lab tested and made in the USA with 90 capsules per bottle.',
    features: ['4-in-1 Magnesium', '5-HTP + B6', 'Restful Sleep'],
    popular: true,
    price: 1899,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 90,
    sizes: ['90 capsules'],
    flavors: ['N/A'],
    benefits: ['Promotes restful, deep sleep', 'Calms the nervous system', 'Supports mood balance and harmony', '5-HTP boosts serotonin production', 'Third-party lab tested for purity'],
    bestFor: 'Sleep & mood support',
    ingredients: 'Magnesium Complex (Magnesium Glycinate, Magnesium Citrate, Magnesium Taurate, Magnesium Oxide), 5-HTP (Griffonia Simplicifolia Seed Extract), Vitamin B6 (Pyridoxine HCl), Vegetable Cellulose Capsule, Rice Flour',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Capsules' },
      { label: 'Magnesium (4-in-1 Complex)', value: '610mg' },
      { label: '5-HTP', value: '100mg' },
      { label: 'Vitamin B6', value: '25mg' },
    ],
  },
  {
    id: 21,
    slug: 'applied-nutrition-calcium-magnesium',
    name: 'Applied Nutrition Calcium & Magnesium',
    category: 'vitamins',
    brand: 'Applied Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/xsceap5u_Applied%20Calcium%20%26%20Magnesium.jpg',
    description: 'Athlete-tested vegan calcium & magnesium for vitality, bone health and muscle function',
    longDescription: 'Applied Nutrition Calcium & Magnesium is an athlete-tested, vegan-certified supplement designed to support vitality, bone health, and optimal muscle function. Calcium is essential for strong bones, teeth, and muscle contractions, while magnesium supports over 300 enzymatic reactions including energy production, protein synthesis, and nervous system regulation. Tested for athletes to ensure it is free from banned substances, making it safe for competitive athletes. 60 capsules per bottle.',
    features: ['Athlete Tested', 'Vegan Certified', 'Vitality Support'],
    popular: true,
    price: 1599,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 60,
    sizes: ['60 capsules'],
    flavors: ['N/A'],
    benefits: ['Supports strong bones and teeth', 'Aids muscle function and recovery', 'Promotes energy production and vitality', 'Tested for athletes - banned substance free', 'Vegan certified formula'],
    bestFor: 'Bone health & vitality',
    ingredients: 'Calcium (as Calcium Carbonate), Magnesium (as Magnesium Oxide, Magnesium Citrate), Vegetable Cellulose Capsule, Magnesium Stearate',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Capsules' },
      { label: 'Calcium', value: '800mg' },
      { label: 'Magnesium', value: '400mg' },
    ],
  },
  {
    id: 22,
    slug: 'applied-nutrition-digestive-enzymes',
    name: 'Applied Nutrition Digestive Enzymes',
    category: 'vitamins',
    brand: 'Applied Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/wgod4sn8_Applied%20Digestive%20Enzymes.jpg',
    description: 'ZyMate Max multi-enzyme complex with lactase, protease & amylase for optimal digestion',
    longDescription: 'Applied Nutrition Digestive Enzymes features the ZyMate Max multi-enzyme complex, a powerful blend of digestive enzymes designed to optimize nutrient absorption and reduce digestive discomfort. It contains lactase to break down lactose (ideal for dairy-based protein shakes), protease to enhance protein digestion, and amylase for carbohydrate breakdown. For athletes consuming high-protein diets, proper digestion is key to actually absorbing the nutrients you consume. Vegan friendly with 60 capsules per bottle.',
    features: ['ZyMate Max', 'Lactase + Protease', 'Vegan Friendly'],
    popular: true,
    price: 1699,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 60,
    sizes: ['60 capsules'],
    flavors: ['N/A'],
    benefits: ['Breaks down lactose for dairy-sensitive athletes', 'Enhances protein digestion and absorption', 'Supports carbohydrate digestion', 'Reduces bloating and digestive discomfort', 'Vegan friendly formula'],
    bestFor: 'Digestive health',
    ingredients: 'ZyMate Max Multi-Enzyme Complex (Lactase, Protease, Amylase, Lipase, Cellulase, Bromelain, Papain), Vegetable Cellulose Capsule, Rice Flour',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Capsule' },
      { label: 'ZyMate Max Enzyme Blend', value: '250mg' },
      { label: 'Lactase', value: '3000 ALU' },
      { label: 'Protease', value: '20000 HUT' },
      { label: 'Amylase', value: '5000 DU' },
    ],
  },
  {
    id: 23,
    slug: 'applied-nutrition-omega-3',
    name: 'Applied Nutrition Omega 3',
    category: 'vitamins',
    brand: 'Applied Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/w8480uxi_Applied%20Omega.jpg',
    description: 'Athlete-tested omega-3 in veggie softgels - 100 servings for heart, brain & joint health',
    longDescription: 'Applied Nutrition Omega 3 delivers essential omega-3 fatty acids in convenient veggie softgels, making it suitable for vegetarians. Each softgel provides EPA and DHA to support cardiovascular health, brain function, joint mobility, and overall wellness. Tested for athletes to ensure compliance with anti-doping regulations, this is a trusted choice for competitive athletes who need clean, effective supplementation. 100 veggie softgels per bottle providing 100 servings.',
    features: ['100 Softgels', 'Veggie Capsules', 'Athlete Tested'],
    popular: true,
    price: 1799,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 100,
    sizes: ['100 veggie softgels'],
    flavors: ['N/A'],
    benefits: ['Supports cardiovascular health', 'Enhances brain function and focus', 'Promotes joint mobility and comfort', 'Tested for athletes - competition safe', 'Veggie softgels for vegetarians'],
    bestFor: 'Heart, brain & joint health',
    ingredients: 'Fish Oil Concentrate, EPA (Eicosapentaenoic Acid), DHA (Docosahexaenoic Acid), Vegetable-Based Softgel Capsule (Modified Starch, Glycerin, Carrageenan), Mixed Tocopherols',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Veggie Softgel' },
      { label: 'Fish Oil', value: '1000mg' },
      { label: 'EPA', value: '180mg' },
      { label: 'DHA', value: '120mg' },
      { label: 'Total Omega-3', value: '300mg' },
    ],
  },
  {
    id: 24,
    slug: 'atom-whey-protein-double-rich-chocolate',
    name: 'ATOM Whey Protein - Double Rich Chocolate',
    category: 'whey',
    brand: 'ATOM',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/r72q2ql5_Atom%20Whey.jpg',
    description: '27g protein per serving with DigestZyme enzymes & probiotics for easy digestion',
    longDescription: 'ATOM Whey Protein goes beyond ordinary with 27g of high-quality protein per serving, enhanced with DigestZyme digestive enzymes and probiotics for superior absorption and gut comfort. The DigestZyme blend ensures fast absorption while being light on your gut, and the added probiotics support digestive health even with high-protein diets. Blind tested and third-party certified for purity, ATOM delivers serious gains without the bloating. Available in Double Rich Chocolate flavor in a 1kg bag.',
    features: ['27g Protein', 'DigestZyme Enzymes', 'Probiotic Powered'],
    popular: true,
    price: 2999,
    stock: 'In Stock',
    protein: '27g',
    calories: 125,
    servings: 28,
    sizes: ['1kg'],
    flavors: ['Double Rich Chocolate'],
    benefits: ['27g high-quality whey protein per serving', 'DigestZyme enzymes for easy digestion', 'Probiotic powered for gut health', 'Blind tested and third-party certified', 'Fast absorbing with zero bloating'],
    bestFor: 'Muscle gain & easy digestion',
    ingredients: 'Whey Protein Concentrate, Whey Protein Isolate, Cocoa Powder, DigestZyme (Multi-Enzyme Complex), Probiotic Blend (Bacillus Coagulans), Natural & Artificial Flavors, Sucralose, Soy Lecithin',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (34g)' },
      { label: 'Calories', value: '125' },
      { label: 'Total Fat', value: '2g' },
      { label: 'Total Carbohydrate', value: '4g' },
      { label: 'Protein', value: '27g' },
      { label: 'DigestZyme', value: '75mg' },
      { label: 'Probiotics', value: '1 Billion CFU' },
    ],
  },
  {
    id: 25,
    slug: 'avvatar-mass-gainer-belgian-chocolate',
    name: 'Avvatar Mass Gainer - Belgian Chocolate',
    category: 'massgainer',
    brand: 'Avvatar',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/l3tdxqvm_Avvatar%20Mass%20Gainer.jpg',
    description: '45.6g protein per serving with 21 vitamins & minerals - sugar-free, gluten-free, soy-free',
    longDescription: 'Avvatar Mass Gainer is a high-calorie, high-protein mass gainer designed for serious weight and muscle gain. Each serving delivers 45.6g of protein and 122g of carbohydrates along with 21 essential vitamins and minerals. What sets it apart is being sugar-free, gluten-free, and soy-free, making it one of the cleanest mass gainers available. The Belgian Chocolate flavour is rich and satisfying. With 33 servings per 2kg container, it provides sustained caloric surplus for hard gainers looking to pack on quality mass. Fresh and pure - from farm to shaker.',
    features: ['45.6g Protein', '21 Vitamins & Minerals', 'Sugar & Gluten Free'],
    popular: true,
    price: 4499,
    stock: 'In Stock',
    protein: '45.6g',
    calories: 750,
    servings: 33,
    sizes: ['2kg'],
    flavors: ['Belgian Chocolate'],
    benefits: ['45.6g high-quality protein per serving', '122g carbohydrates for caloric surplus', '21 essential vitamins and minerals', 'Sugar-free, gluten-free, and soy-free', 'Clean mass gainer for quality gains'],
    bestFor: 'Mass gain & bulking',
    ingredients: 'Whey Protein Concentrate, Maltodextrin, Cocoa Powder, Vitamin & Mineral Premix (Vitamin C, Vitamin D, Vitamin B12, B6, B1, B2, Niacin, Folate, Biotin, Pantothenic Acid, Calcium, Iron, Magnesium, Zinc, Copper, Manganese, Chromium, Molybdenum, Selenium), Natural & Artificial Flavors, Sucralose',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (approx. 60g)' },
      { label: 'Calories', value: '~750' },
      { label: 'Protein', value: '45.6g' },
      { label: 'Total Carbohydrate', value: '122g' },
      { label: 'Total Fat', value: '3g' },
      { label: 'Sugars', value: '0g' },
      { label: 'Vitamins & Minerals', value: '21 types' },
    ],
  },
  {
    id: 26,
    slug: 'avvatar-whey-protein-belgian-chocolate',
    name: 'Avvatar Whey Protein - Belgian Chocolate',
    category: 'whey',
    brand: 'Avvatar',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/z5v3w9gr_AVVATAR.jpg',
    description: '24g protein, 5.36g BCAAs per serving - sugar-free, gluten-free, soy-free, 57 servings',
    longDescription: 'Avvatar Whey Protein delivers 24g of high-quality whey protein per serving with 5.36g of BCAAs and 3.46g of Glutamic Acid for superior muscle recovery and growth. This clean formula is sugar-free, gluten-free, and soy-free, making it suitable for athletes with dietary restrictions. With 57 servings per 2kg tub, it offers exceptional value. The Belgian Chocolate flavour is rich and creamy. Fresh and pure - sourced from Avvatar\'s own farms to your shaker, ensuring quality from the source.',
    features: ['24g Protein', '5.36g BCAAs', 'Sugar & Gluten Free'],
    popular: true,
    price: 3799,
    stock: 'In Stock',
    protein: '24g',
    calories: 120,
    servings: 57,
    sizes: ['2kg'],
    flavors: ['Belgian Chocolate'],
    benefits: ['24g premium whey protein per serving', '5.36g BCAAs for muscle recovery', '3.46g Glutamic Acid for growth', 'Sugar-free, gluten-free, and soy-free', '57 servings per tub - great value'],
    bestFor: 'Muscle building & recovery',
    ingredients: 'Whey Protein Concentrate, Cocoa Powder, Natural & Artificial Flavors, Sucralose, Soy Lecithin (trace), Vitamins & Minerals Blend',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (35g)' },
      { label: 'Calories', value: '120' },
      { label: 'Protein', value: '24g' },
      { label: 'BCAAs', value: '5.36g' },
      { label: 'Glutamic Acid', value: '3.46g' },
      { label: 'Other EAAs', value: '5.36g' },
      { label: 'Sugars', value: '0g' },
    ],
  },
  {
    id: 27,
    slug: 'natrol-biotin-10000mcg',
    name: 'Natrol Biotin 10,000mcg',
    category: 'vitamins',
    brand: 'Natrol',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/8qv6kang_IMG_5419.jpeg',
    description: 'Maximum strength biotin for healthy hair, skin, nails & metabolism support - 100% drug free',
    longDescription: 'Natrol Biotin 10,000mcg is a maximum strength formula that supports healthy hair, skin, and nails while promoting healthy carbohydrate, fat, and protein metabolism. Biotin is a B-complex vitamin essential for converting food into cellular energy and maintaining the health of hair, skin, and nails. This high-potency 10,000mcg dosage is ideal for individuals looking to address biotin deficiency and support beauty from within. 100% drug free with 100 tablets per bottle.',
    features: ['10,000mcg Biotin', 'Hair, Skin & Nails', '100% Drug Free'],
    popular: true,
    price: 1299,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 100,
    sizes: ['100 tablets'],
    flavors: ['N/A'],
    benefits: ['Promotes healthy, strong hair growth', 'Supports clear, radiant skin', 'Strengthens nails', 'Supports carb, fat & protein metabolism', '100% drug free formula'],
    bestFor: 'Hair, skin & nail health',
    ingredients: 'Biotin (as d-Biotin), Calcium (as Dicalcium Phosphate), Cellulose, Stearic Acid, Silica, Magnesium Stearate',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Tablet' },
      { label: 'Biotin', value: '10,000mcg' },
      { label: 'Calcium', value: '50mg' },
    ],
  },
  {
    id: 28,
    slug: 'myfitness-dark-chocolate-peanut-butter',
    name: 'MyFitness Dark Chocolate Peanut Butter Crispy',
    category: 'accessories',
    brand: 'MyFitness',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/1dxeepts_IMG_5418.jpeg',
    description: 'High protein peanut butter with added whey, dark chocolate flavour and crispy texture - 1kg',
    longDescription: 'MyFitness Dark Chocolate Peanut Butter Crispy is a high-protein peanut butter enriched with added whey protein for fitness enthusiasts who want more from their spread. The rich dark chocolate flavour combined with crispy crunchy bits creates an indulgent taste experience while delivering serious protein content. Made with premium roasted peanuts and real dark chocolate, it is perfect on toast, in smoothies, with oats, or straight from the jar. Vegetarian friendly with 1kg per tub.',
    features: ['High Protein', 'Added Whey', 'Dark Chocolate Crispy'],
    popular: true,
    price: 599,
    stock: 'In Stock',
    protein: '30g per 100g',
    calories: 550,
    servings: 30,
    sizes: ['1kg'],
    flavors: ['Dark Chocolate Crispy'],
    benefits: ['High protein with added whey', 'Rich dark chocolate flavour', 'Crispy crunchy texture', 'Perfect pre/post workout snack', 'Vegetarian friendly'],
    bestFor: 'High-protein snacking',
    ingredients: 'Roasted Peanuts, Dark Chocolate (Cocoa Mass, Sugar, Cocoa Butter), Whey Protein Concentrate, Rice Crisps, Palm Oil, Salt',
    supplementFacts: [
      { label: 'Serving Size', value: '32g (2 tablespoons)' },
      { label: 'Calories', value: '180' },
      { label: 'Protein', value: '10g' },
      { label: 'Total Fat', value: '12g' },
      { label: 'Total Carbohydrate', value: '10g' },
      { label: 'Sugars', value: '5g' },
    ],
  },
  {
    id: 29,
    slug: 'muscletech-nitrotech-whey-gold',
    name: 'MuscleTech Nitro-Tech Whey Gold',
    category: 'whey',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/ld6pxiyl_IMG_5417.webp',
    description: 'Gourmet whey protein with 24g protein per serving - Double Rich Chocolate, 5lbs (2.27kg)',
    longDescription: 'MuscleTech Nitro-Tech Whey Gold is a gourmet-quality whey protein powder delivering 24g of ultra-premium protein per serving. Featuring whey protein peptides and isolate as the primary ingredients, this formula provides superior protein quality with an exceptional Double Rich Chocolate taste. Nitro-Tech Whey Gold is designed for athletes who demand both performance and flavour from their protein supplement. With 5lbs (2.27kg) per container, it offers excellent value for serious trainers.',
    features: ['24g Protein', 'Gourmet Whey', '5lbs / 2.27kg'],
    popular: true,
    price: 7999,
    stock: 'In Stock',
    protein: '24g',
    calories: 130,
    servings: 69,
    sizes: ['5lbs (2.27kg)'],
    flavors: ['Double Rich Chocolate'],
    benefits: ['24g ultra-premium whey protein per serving', 'Gourmet Double Rich Chocolate taste', 'Whey peptides and isolate blend', 'Supports muscle building and recovery', 'Excellent value with 69 servings'],
    bestFor: 'Muscle building & recovery',
    ingredients: 'Whey Protein Isolate, Whey Protein Peptides, Whey Protein Concentrate, Cocoa Powder, Natural & Artificial Flavors, Soy Lecithin, Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (33g)' },
      { label: 'Calories', value: '130' },
      { label: 'Total Fat', value: '2g' },
      { label: 'Total Carbohydrate', value: '3g' },
      { label: 'Protein', value: '24g' },
      { label: 'BCAAs', value: '5.5g' },
      { label: 'Glutamine & Glutamic Acid', value: '4g' },
    ],
  },
  {
    id: 30,
    slug: 'muscletech-nitrotech-strawberry',
    name: 'MuscleTech Nitro-Tech Whey Protein - Strawberry',
    category: 'whey',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/oi0kisxf_IMG_5416.jpeg',
    description: '30g protein + 3g creatine per serving - builds 70% more muscle than regular whey, 4lbs',
    longDescription: 'MuscleTech Nitro-Tech is the ultimate muscle building whey protein formula, clinically shown to build 70% more muscle than regular whey protein. Each serving delivers 30g of protein primarily from whey protein isolate and peptides, plus 3g of clinically dosed creatine monohydrate and 6.7g of BCAAs. This powerful combination supports muscle growth, improves recovery, and enhances strength and performance. Available in refreshing Strawberry flavour with 4lbs (1.81kg) per container.',
    features: ['30g Protein', '3g Creatine', '70% More Muscle'],
    popular: true,
    price: 6999,
    stock: 'In Stock',
    protein: '30g',
    calories: 160,
    servings: 40,
    sizes: ['4lbs (1.81kg)'],
    flavors: ['Strawberry'],
    benefits: ['Builds 70% more muscle than regular whey', '30g premium whey protein per serving', '3g creatine monohydrate for strength', '6.7g BCAAs for recovery', 'Clinically researched formula'],
    bestFor: 'Muscle building & strength',
    ingredients: 'Whey Protein Isolate, Whey Protein Peptides, Whey Protein Concentrate, Creatine Monohydrate, Natural & Artificial Flavors, Soy Lecithin, Sucralose, Acesulfame Potassium, Red Beet Color',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (44g)' },
      { label: 'Calories', value: '160' },
      { label: 'Total Fat', value: '2.5g' },
      { label: 'Total Carbohydrate', value: '4g' },
      { label: 'Protein', value: '30g' },
      { label: 'Creatine Monohydrate', value: '3g' },
      { label: 'BCAAs', value: '6.7g' },
    ],
  },
  {
    id: 31,
    slug: 'muscletech-nitrotech-milk-chocolate',
    name: 'MuscleTech Nitro-Tech Whey Protein - Milk Chocolate',
    category: 'whey',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/phwa8wtr_IMG_5415.jpeg',
    description: '30g protein + 3g creatine per serving - ultimate muscle building formula, Milk Chocolate, 1.81kg',
    longDescription: 'MuscleTech Nitro-Tech Whey Protein in Milk Chocolate is the ultimate muscle building formula backed by research. Each serving delivers 30g of protein from a premium whey blend, 3g of clinically dosed creatine monohydrate, and 6.7g of BCAAs. The formula is designed to build more muscle than regular whey, improve recovery, and support strength and performance. The rich Milk Chocolate flavour makes every post-workout shake a treat. 1.81kg per container for serious athletes.',
    features: ['30g Protein', '3g Creatine', '6.7g BCAAs'],
    popular: true,
    price: 6999,
    stock: 'In Stock',
    protein: '30g',
    calories: 160,
    servings: 40,
    sizes: ['4lbs (1.81kg)'],
    flavors: ['Milk Chocolate'],
    benefits: ['Builds more muscle than regular whey', '30g premium whey protein per serving', '3g creatine monohydrate for strength', '6.7g BCAAs for enhanced recovery', 'Supports strength and performance'],
    bestFor: 'Muscle building & performance',
    ingredients: 'Whey Protein Isolate, Whey Protein Peptides, Whey Protein Concentrate, Creatine Monohydrate, Cocoa Powder, Natural & Artificial Flavors, Soy Lecithin, Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (44g)' },
      { label: 'Calories', value: '160' },
      { label: 'Total Fat', value: '2.5g' },
      { label: 'Total Carbohydrate', value: '4g' },
      { label: 'Protein', value: '30g' },
      { label: 'Creatine Monohydrate', value: '3g' },
      { label: 'BCAAs', value: '6.7g' },
    ],
  },
  {
    id: 32,
    slug: 'muscletech-hydroxycut-super-elite',
    name: 'MuscleTech Hydroxycut Super Elite',
    category: 'fatburner',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/r0eb0r44_IMG_5414.webp',
    description: 'Advanced fat metabolism support with C. Canephora Robusta, Coleus Forskohlii & Turmeric - 100 veggie capsules',
    longDescription: 'MuscleTech Hydroxycut Super Elite is an advanced thermogenic formula designed to support fat metabolism while increasing alertness and performance. Featuring a scientifically tested blend of C. Canephora Robusta Extract (200mg), Choline (100mg), Coleus Forskohlii Root Extract (100mg), and Turmeric Extract (100mg), this nutraceutical-grade supplement helps your body burn fat more efficiently. Authenticity verified with 100 veggie capsules per bottle. Contains caffeine for enhanced energy and focus.',
    features: ['Fat Metabolism', 'Alertness & Energy', 'Authenticity Verified'],
    popular: true,
    price: 3499,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 100,
    sizes: ['100 veggie capsules'],
    flavors: ['N/A'],
    benefits: ['Supports fat metabolism and weight management', 'Increases alertness and mental focus', 'Enhances physical performance', 'Scientifically tested key ingredients', 'Authenticity verified nutraceutical'],
    bestFor: 'Fat loss & energy',
    ingredients: 'C. Canephora Robusta Extract (200mg), Choline (100mg), Coleus Forskohlii Root Extract (100mg), Turmeric Extract (100mg), Caffeine, Vegetable Cellulose Capsule',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Veggie Capsules' },
      { label: 'C. Canephora Robusta Extract', value: '200mg' },
      { label: 'Choline', value: '100mg' },
      { label: 'Coleus Forskohlii Root Extract', value: '100mg' },
      { label: 'Turmeric Extract', value: '100mg' },
    ],
  },
  {
    id: 33,
    slug: 'muscletech-hydroxycut-hardcore-elite',
    name: 'MuscleTech Hydroxycut Hardcore Elite',
    category: 'fatburner',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/h1t515qn_IMG_5413.jpeg',
    description: 'Extreme energy & weight loss with rapid-release thermo caps - scientifically tested formula, 100 caps',
    longDescription: 'MuscleTech Hydroxycut Hardcore Elite is designed for extreme energy and weight loss support. This rapid-release thermo cap formula features scientifically tested key ingredients including C. Canephora Robusta Extract (200mg), Coleus Forskohlii Extract (100mg), and L-Theanine (100mg). The combination provides a potent thermogenic effect while L-Theanine ensures smooth, jitter-free energy and enhanced mental focus. The rapid-release capsule technology ensures fast absorption for quick results. 100 thermo caps per bottle.',
    features: ['Extreme Energy', 'Rapid-Release Caps', 'L-Theanine Focus'],
    popular: true,
    price: 3299,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 100,
    sizes: ['100 rapid-release thermo caps'],
    flavors: ['N/A'],
    benefits: ['Extreme energy and weight loss support', 'Boosts mental focus with L-Theanine', 'Rapid-release capsule for fast absorption', 'Scientifically tested ingredients', 'Smooth, jitter-free energy'],
    bestFor: 'Weight loss & extreme energy',
    ingredients: 'C. Canephora Robusta Extract (200mg), Coleus Forskohlii Extract (100mg), L-Theanine (100mg), Caffeine Anhydrous, Gelatin Capsule, Magnesium Stearate, Silicon Dioxide',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Rapid-Release Caps' },
      { label: 'C. Canephora Robusta Extract', value: '200mg' },
      { label: 'Coleus Forskohlii Extract', value: '100mg' },
      { label: 'L-Theanine', value: '100mg' },
    ],
  },
  {
    id: 34,
    slug: 'muscletech-eaa-plus-energy-sour-apple',
    name: 'MuscleTech EAA+ Energy - Sour Apple',
    category: 'preworkout',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/xqeecwcg_IMG_5412.webp',
    description: '7.49g essential amino acids + 100mg caffeine per serving for strength, recovery & energy - 30 servings',
    longDescription: 'MuscleTech EAA+ Energy combines 7.49g of essential amino acids with 100mg of caffeine per serving to deliver a powerful combination of muscle recovery support and clean energy. EAAs are the building blocks of muscle protein synthesis, and when combined with caffeine, they help fuel intense training sessions while supporting recovery. Clinically shown to support a 40% increase in strength. Available in refreshing Sour Apple flavour with 30 servings per 396g container. Tested and approved for adult sportspersons.',
    features: ['7.49g EAAs', '100mg Caffeine', '40% Strength Boost'],
    popular: true,
    price: 2499,
    stock: 'In Stock',
    protein: '0g',
    calories: 15,
    servings: 30,
    sizes: ['396g'],
    flavors: ['Sour Apple'],
    benefits: ['7.49g essential amino acids for recovery', '100mg caffeine for clean energy', 'Supports 40% increase in strength', 'Enhances muscle protein synthesis', 'Refreshing Sour Apple flavour'],
    bestFor: 'Intra-workout energy & recovery',
    ingredients: 'Essential Amino Acid Blend (L-Leucine, L-Isoleucine, L-Valine, L-Lysine, L-Threonine, L-Phenylalanine, L-Methionine, L-Histidine, L-Tryptophan), Caffeine Anhydrous, Citric Acid, Natural & Artificial Flavors, Sucralose, Silicon Dioxide',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (13.2g)' },
      { label: 'EAA Blend', value: '7.49g' },
      { label: 'Caffeine', value: '100mg' },
      { label: 'BCAAs (included in EAAs)', value: '5g' },
    ],
  },
  {
    id: 35,
    slug: 'muscletech-platinum-100-creatine',
    name: 'MuscleTech Platinum 100% Creatine',
    category: 'creatine',
    brand: 'MuscleTech',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/v3mk43ha_IMG_5411.jpeg',
    description: 'Pure micronized creatine monohydrate - 3g per serving, 83 servings, scientifically researched',
    longDescription: 'MuscleTech Platinum 100% Creatine delivers 3g of pure, ultra-premium micronized creatine monohydrate per serving. Creatine is the most scientifically researched supplement proven to increase muscle power, boost strength, and enhance athletic performance. The micronized formula ensures superior mixability and absorption with zero grit. Unflavoured for versatile mixing with any beverage or protein shake. With 83 servings per 250g container, it is one of the best value creatine supplements available.',
    features: ['3g Creatine', '83 Servings', 'Unflavoured'],
    popular: true,
    price: 1199,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 83,
    sizes: ['250g'],
    flavors: ['Unflavored'],
    benefits: ['Increases muscle power output', 'Boosts strength for heavier lifts', 'Enhances athletic performance', 'Scientifically researched and proven', 'Ultra-premium micronized formula'],
    bestFor: 'Strength & power',
    ingredients: '100% Micronized Creatine Monohydrate',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (3g)' },
      { label: 'Creatine Monohydrate', value: '3g' },
    ],
  },
  {
    id: 36,
    slug: 'muscleblaze-l-carnitine-pro',
    name: 'MuscleBlaze L-Carnitine Pro - Tangy Orange',
    category: 'fatburner',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/vhnpojtp_IMG_5410.jpeg',
    description: 'Triple strength liquid L-Carnitine 3300mg with Vitamin B5 for fat metabolism & energy - 450ml',
    longDescription: 'MuscleBlaze L-Carnitine Pro is a triple strength liquid formula delivering 3300mg of L-Carnitine per serving fortified with Vitamin B5. L-Carnitine plays a crucial role in transporting fatty acids to your mitochondria where they are converted into energy, making it essential for fat metabolism and endurance. The liquid format ensures rapid absorption compared to capsules, and the Tangy Orange flavour makes it pleasant to consume. Vitamin B5 supports energy metabolism and reduces fatigue. 450ml bottle for sustained daily use.',
    features: ['3300mg L-Carnitine', 'Triple Strength', 'Vitamin B5'],
    popular: true,
    price: 1299,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 30,
    sizes: ['450ml'],
    flavors: ['Tangy Orange'],
    benefits: ['3300mg L-Carnitine for fat metabolism', 'Triple strength liquid formula', 'Rapid absorption liquid format', 'Vitamin B5 reduces fatigue', 'Supports endurance and energy'],
    bestFor: 'Fat burning & endurance',
    ingredients: 'L-Carnitine (3300mg), Vitamin B5 (Pantothenic Acid), Purified Water, Citric Acid, Natural Orange Flavor, Sucralose, Potassium Sorbate, Sodium Benzoate',
    supplementFacts: [
      { label: 'Serving Size', value: '15ml' },
      { label: 'L-Carnitine', value: '3300mg' },
      { label: 'Vitamin B5', value: '5mg' },
      { label: 'Calories', value: '10' },
    ],
  },
  {
    id: 37,
    slug: 'muscleblaze-mass-gainer-xxl-chocolate',
    name: 'MuscleBlaze Mass Gainer XXL - Chocolate',
    category: 'massgainer',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/a6btwj96_IMG_5409.jpeg',
    description: '1361 kcal & 76.5g protein per serving, 5 protein sources with digestive enzymes - 3kg',
    longDescription: 'MuscleBlaze Mass Gainer XXL is a powerhouse mass gainer delivering an incredible 1361 kcal and 76.5g of protein per serving from 5 different protein sources. The multi-source protein blend provides a sustained release of amino acids for maximum muscle growth. Added digestive enzymes ensure smooth absorption even with high calorie intake, reducing bloating and discomfort. Chocolate flavoured for great taste. At 3kg (6.6lb) per container, it is built for hard gainers serious about packing on quality mass.',
    features: ['1361 kcal', '76.5g Protein', '5 Protein Sources'],
    popular: true,
    price: 3999,
    stock: 'In Stock',
    protein: '76.5g',
    calories: 1361,
    servings: 14,
    sizes: ['3kg (6.6lb)'],
    flavors: ['Chocolate'],
    benefits: ['Massive 1361 kcal per serving for caloric surplus', '76.5g protein from 5 different sources', 'Sustained amino acid release for growth', 'Added digestive enzymes for smooth absorption', 'Perfect for hard gainers and bulking'],
    bestFor: 'Serious mass gain',
    ingredients: 'Maltodextrin, Whey Protein Concentrate, Milk Protein Concentrate, Soy Protein Isolate, Calcium Caseinate, Whey Protein Isolate, Cocoa Powder, Digestive Enzyme Blend, Natural & Artificial Flavors, Sucralose',
    supplementFacts: [
      { label: 'Serving Size', value: '3 Scoops (approx. 200g)' },
      { label: 'Calories', value: '1361 kcal' },
      { label: 'Protein', value: '76.5g' },
      { label: 'Total Carbohydrate', value: '225g' },
      { label: 'Total Fat', value: '9g' },
      { label: 'Protein Sources', value: '5 types' },
      { label: 'Digestive Enzymes', value: 'Included' },
    ],
  },
  {
    id: 38,
    slug: 'muscleblaze-wrathx-preworkout-fruit-fury',
    name: 'MuscleBlaze WRATHX Pre-Workout - Fruit Fury',
    category: 'preworkout',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/9euo5tse_IMG_5408.jpeg',
    description: '4500mg Citrulline, 3500mg Beta Alanine, 200mg Caffeine with Creapure & BioPerine - 340g',
    longDescription: 'MuscleBlaze WRATHX is a high-stim pre-workout formula engineered for intense training sessions. Featuring clinical doses of L-Citrulline DL-Malate (4500mg) for skin-splitting pumps, Beta Alanine (3500mg) for endurance, NitroBlaZe (3000mg) for nitric oxide production, and Caffeine (200mg) for explosive energy. Enhanced with Creapure certified creatine and BioPerine for superior bioavailability. Fruit Fury flavour with 340g per container. Designed for adult sportspersons who demand maximum performance.',
    features: ['4500mg Citrulline', '3500mg Beta Alanine', '200mg Caffeine'],
    popular: true,
    price: 2299,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 25,
    sizes: ['340g'],
    flavors: ['Fruit Fury'],
    benefits: ['4500mg L-Citrulline for massive muscle pumps', '3500mg Beta Alanine for endurance', '200mg caffeine for explosive energy', 'Creapure certified creatine for strength', 'BioPerine for enhanced absorption'],
    bestFor: 'Intense pre-workout performance',
    ingredients: 'L-Citrulline DL-Malate (4500mg), Beta Alanine (3500mg), NitroBlaZe Blend (3000mg), Caffeine Anhydrous (200mg), Creapure Creatine Monohydrate, BioPerine (Black Pepper Extract), Citric Acid, Natural & Artificial Flavors, Sucralose',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (13.6g)' },
      { label: 'L-Citrulline DL-Malate', value: '4500mg' },
      { label: 'Beta Alanine', value: '3500mg' },
      { label: 'NitroBlaZe', value: '3000mg' },
      { label: 'Caffeine', value: '200mg' },
    ],
  },
  {
    id: 39,
    slug: 'muscleblaze-zma',
    name: 'MuscleBlaze MB ZMA',
    category: 'vitamins',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/qgjp9wh1_IMG_5407.jpeg',
    description: 'Zinc, Magnesium & Vitamin B6 with L-Lysine - 100% RDA for muscle strength & recovery, 60 tablets',
    longDescription: 'MuscleBlaze MB ZMA is a scientifically formulated supplement combining Zinc, Magnesium, Vitamin B6, and L-Lysine Hydrochloride to support muscle strength and recovery. Each tablet provides 100% of your Recommended Daily Allowance of Magnesium, Zinc, and Vitamin B6 - three minerals critical for testosterone production, protein synthesis, muscle recovery, and sleep quality. L-Lysine enhances calcium absorption and supports immune function. 60 tablets per bottle for a full month of daily support.',
    features: ['100% RDA ZMA', 'L-Lysine Added', 'Muscle Recovery'],
    popular: true,
    price: 699,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 60,
    sizes: ['60 tablets'],
    flavors: ['N/A'],
    benefits: ['100% RDA of Zinc, Magnesium & B6', 'Supports muscle strength and recovery', 'Promotes healthy testosterone levels', 'L-Lysine for calcium absorption and immunity', 'Improves sleep quality for better recovery'],
    bestFor: 'Recovery & hormonal support',
    ingredients: 'Zinc (as Zinc Gluconate), Magnesium (as Magnesium Oxide), Vitamin B6 (as Pyridoxine HCl), L-Lysine Hydrochloride, Cellulose, Stearic Acid, Magnesium Stearate',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Tablet' },
      { label: 'Zinc', value: '10mg (100% RDA)' },
      { label: 'Magnesium', value: '340mg (100% RDA)' },
      { label: 'Vitamin B6', value: '2mg (100% RDA)' },
      { label: 'L-Lysine HCl', value: '100mg' },
    ],
  },
  {
    id: 40,
    slug: 'muscleblaze-fit-high-protein-oats',
    name: 'MuscleBlaze FIT High Protein Oats - Dark Chocolate',
    category: 'accessories',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/m0tf2lb1_IMG_5406.jpeg',
    description: '22g protein per serving with rolled oats, super seeds & raisins in dark chocolate flavour - 1kg',
    longDescription: 'MuscleBlaze FIT High Protein Oats combines the wholesome goodness of rolled oats with 22g of protein per serving, super seeds, and raisins in a delicious Dark Chocolate flavour. This is the perfect high-protein breakfast for athletes and fitness enthusiasts who want to start their day with serious nutrition. The combination of complex carbs from oats, protein for muscle maintenance, and healthy fats from super seeds provides sustained energy throughout the morning. Vegetarian friendly with 1kg per pack.',
    features: ['22g Protein', 'Rolled Oats', 'Super Seeds & Raisins'],
    popular: true,
    price: 799,
    stock: 'In Stock',
    protein: '22g',
    calories: 350,
    servings: 12,
    sizes: ['1kg'],
    flavors: ['Dark Chocolate'],
    benefits: ['22g protein per serving for muscle support', 'Rolled oats for sustained energy', 'Super seeds for healthy fats and fiber', 'Raisins for natural sweetness and iron', 'Perfect high-protein breakfast'],
    bestFor: 'High-protein breakfast',
    ingredients: 'Rolled Oats, Whey Protein Concentrate, Dark Chocolate Chips, Super Seeds (Chia, Flax, Pumpkin), Raisins, Cocoa Powder, Natural Flavor, Sucralose',
    supplementFacts: [
      { label: 'Serving Size', value: '80g' },
      { label: 'Calories', value: '350' },
      { label: 'Protein', value: '22g' },
      { label: 'Total Carbohydrate', value: '45g' },
      { label: 'Dietary Fiber', value: '6g' },
      { label: 'Total Fat', value: '8g' },
    ],
  },
  {
    id: 41,
    slug: 'muscleblaze-high-protein-gold-gainer',
    name: 'MuscleBlaze High Protein Gold Gainer - Chocolate',
    category: 'massgainer',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_9fa5a733-b30b-4e13-845a-b41de39f5575/artifacts/wgutgkvc_IMG_5405.jpeg',
    description: '909 kcal, 69g protein, 6.12g BCAAs & 3000mg creatine per serving - Gold Standard mass gainer, 3kg',
    longDescription: 'MuscleBlaze High Protein Gold Gainer is the Gold Standard of mass gainers, delivering 909 kcal and a massive 69g of protein per serving. Fortified with 6.12g of BCAAs for muscle recovery and 3000mg of Creatine Monohydrate for strength and power, this premium formula is designed for serious athletes who want quality mass without excessive fat gain. The high protein-to-calorie ratio ensures you build lean muscle while in a caloric surplus. Chocolate flavour with 3kg (6.6lb) per container.',
    features: ['909 kcal', '69g Protein', '3000mg Creatine'],
    popular: true,
    price: 4299,
    stock: 'In Stock',
    protein: '69g',
    calories: 909,
    servings: 14,
    sizes: ['3kg (6.6lb)'],
    flavors: ['Chocolate'],
    benefits: ['909 kcal for caloric surplus', '69g high-quality protein per serving', '6.12g BCAAs for muscle recovery', '3000mg Creatine Monohydrate for strength', 'Premium Gold Standard formula'],
    bestFor: 'Lean mass gain',
    ingredients: 'Maltodextrin, Whey Protein Concentrate, Whey Protein Isolate, Cocoa Powder, Creatine Monohydrate, BCAAs (L-Leucine, L-Isoleucine, L-Valine), Natural & Artificial Flavors, Digestive Enzymes, Sucralose',
    supplementFacts: [
      { label: 'Serving Size', value: '3 Scoops (approx. 180g)' },
      { label: 'Calories', value: '909 kcal' },
      { label: 'Protein', value: '69g' },
      { label: 'BCAAs', value: '6.12g' },
      { label: 'Creatine Monohydrate', value: '3000mg' },
      { label: 'Total Carbohydrate', value: '130g' },
    ],
  },
  {
    id: 42,
    slug: 'muscleblaze-fish-oil-gold-3x',
    name: 'MuscleBlaze Fish Oil Gold 3X Strength',
    category: 'vitamins',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/rghlajrb_IMG_5403.jpeg',
    description: '1300mg Fish Oil with 500mg EPA & 400mg DHA per capsule - 3X Strength, 60 soft gelatin capsules',
    longDescription: 'MuscleBlaze Fish Oil Gold 3X Strength delivers a potent dose of omega-3 fatty acids in every capsule. With 1300mg of premium fish oil providing 500mg EPA and 400mg DHA per serving, this formula offers 3X the strength of standard fish oil supplements. EPA and DHA are essential fatty acids that support heart health, brain function, joint mobility, and overall wellness. The soft gelatin capsule form ensures easy swallowing and better absorption. Ideal for athletes and fitness enthusiasts who need high-dose omega-3 support for recovery and inflammation management.',
    features: ['1300mg Fish Oil', '500mg EPA', '400mg DHA'],
    popular: false,
    price: 699,
    stock: 'In Stock',
    protein: '0g',
    calories: 15,
    servings: 60,
    sizes: ['60 Capsules'],
    flavors: ['Unflavored'],
    benefits: ['3X strength omega-3 formula', 'Supports heart and cardiovascular health', 'Promotes brain function and cognitive health', 'Reduces joint inflammation and supports mobility', 'Soft gelatin capsules for easy absorption'],
    bestFor: 'Heart, brain & joint health',
    ingredients: 'Fish Oil Concentrate (from Anchovy, Sardine, Mackerel), Gelatin, Glycerin, Purified Water, Mixed Tocopherols (Preservative)',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Capsule' },
      { label: 'Fish Oil', value: '1300mg' },
      { label: 'EPA (Eicosapentaenoic Acid)', value: '500mg' },
      { label: 'DHA (Docosahexaenoic Acid)', value: '400mg' },
      { label: 'Total Omega-3 Fatty Acids', value: '900mg' },
    ],
  },
  {
    id: 43,
    slug: 'muscleblaze-fish-oil-1000mg',
    name: 'MuscleBlaze Fish Oil 1000 MG',
    category: 'vitamins',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/bm8ecdus_IMG_5402.jpeg',
    description: '1000mg Fish Oil soft gelatin capsules - Trustified Certified with 100% Blind Testing, 90 capsules',
    longDescription: 'MuscleBlaze Fish Oil 1000 MG provides essential omega-3 fatty acids in a convenient soft gelatin capsule. Each capsule delivers 1000mg of fish oil containing EPA and DHA, the two most important omega-3 fatty acids for overall health. This product is Trustified Certified with 100% Blind Testing, ensuring the highest standards of quality, purity, and potency. Regular intake supports cardiovascular health, brain function, eye health, and helps manage inflammation from intense training. A daily essential for anyone serious about their health and fitness.',
    features: ['1000mg Fish Oil', 'Trustified Certified', '100% Blind Tested'],
    popular: false,
    price: 499,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 90,
    sizes: ['90 Capsules'],
    flavors: ['Unflavored'],
    benefits: ['Trustified Certified for guaranteed purity', '100% Blind Testing for quality assurance', 'Supports heart and cardiovascular health', 'Promotes healthy brain and eye function', 'Essential daily omega-3 supplementation'],
    bestFor: 'Daily omega-3 supplementation',
    ingredients: 'Fish Oil (from Marine Fish), Gelatin, Glycerin, Purified Water, Mixed Tocopherols (Antioxidant)',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Capsule' },
      { label: 'Fish Oil', value: '1000mg' },
      { label: 'EPA (Eicosapentaenoic Acid)', value: '180mg' },
      { label: 'DHA (Docosahexaenoic Acid)', value: '120mg' },
      { label: 'Total Omega-3 Fatty Acids', value: '300mg' },
    ],
  },
  {
    id: 44,
    slug: 'muscleblaze-creamp-creatine-sunset-mango',
    name: 'MuscleBlaze CreaMP Micronised Creatine Monohydrate - Sunset Mango',
    category: 'creatine',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/el6hft6g_IMG_5401.webp',
    description: '3g Micronised Creatine Monohydrate per serving - Sunset Mango flavour, Trustified Certified, 320g',
    longDescription: 'MuscleBlaze CreaMP Micronised Creatine Monohydrate is a premium creatine supplement designed for athletes who want superior strength and performance. Each serving delivers 3g of micronised creatine monohydrate, processed into ultra-fine particles for better solubility and faster absorption. The Sunset Mango flavour makes it a refreshing and enjoyable addition to your workout routine, unlike unflavoured creatine powders. Trustified Certified with rigorous quality testing, this creatine supplement helps increase phosphocreatine stores in your muscles, boosting ATP production for explosive power during high-intensity training.',
    features: ['3g Creatine', 'Micronised', 'Sunset Mango'],
    popular: false,
    price: 799,
    stock: 'In Stock',
    protein: '0g',
    calories: 12,
    servings: 100,
    sizes: ['320g'],
    flavors: ['Sunset Mango'],
    benefits: ['Micronised for superior absorption and mixability', 'Increases muscle strength and power output', 'Boosts ATP production for explosive performance', 'Trustified Certified for quality assurance', 'Delicious Sunset Mango flavour'],
    bestFor: 'Strength & power output',
    ingredients: 'Creatine Monohydrate (Micronised), Citric Acid, Natural & Artificial Mango Flavoring, Sucralose, Silicon Dioxide',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (3.2g)' },
      { label: 'Creatine Monohydrate', value: '3g' },
      { label: 'Calories', value: '12' },
      { label: 'Total Carbohydrate', value: '0g' },
      { label: 'Sugars', value: '0g' },
    ],
  },
  {
    id: 45,
    slug: 'muscleblaze-biozyme-5in1-multivitamin',
    name: 'MuscleBlaze Biozyme 5-in-1 Multivitamin For Men',
    category: 'vitamins',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/h4xccnnt_IMG_5400.jpeg',
    description: '5-in-1 formula: Vitamins, Minerals, Joint Blend, Testosterone Booster & MB EnzymePro - 90 tablets for men',
    longDescription: 'MuscleBlaze Biozyme 5-in-1 Multivitamin For Men is a comprehensive health supplement that goes beyond basic vitamins. This advanced 5-in-1 formula combines a Vitamins Blend, Minerals Blend, Joint Support Blend, Testosterone Booster Blend, and the proprietary MB EnzymePro technology for 50% higher protein absorption. Trustified Certified with 100% Blind Testing, this multivitamin was a Finalist at the NutraIngredients Asia Awards 2023 and recognized as Product of the Year in Sports Nutrition. Designed specifically for active men, it covers all bases from daily nutrition to joint health and hormonal support. 90 tablets in convenient sachets.',
    features: ['5-in-1 Formula', 'MB EnzymePro', '50% Higher Absorption'],
    popular: true,
    price: 1099,
    stock: 'In Stock',
    protein: '0g',
    calories: 5,
    servings: 30,
    sizes: ['90 Tablets (30 Sachets)'],
    flavors: ['Unflavored'],
    benefits: ['5-in-1 comprehensive formula for total health', '50% higher protein absorption with MB EnzymePro', 'Joint support blend for active lifestyles', 'Testosterone booster blend for men', 'Trustified Certified with 100% Blind Testing'],
    bestFor: 'Complete daily nutrition for men',
    ingredients: 'Vitamin A, Vitamin C, Vitamin D3, Vitamin E, Vitamin K2, B-Complex Vitamins, Zinc, Magnesium, Calcium, Iron, Selenium, Ashwagandha Extract, Fenugreek Extract, Boswellia Serrata, Glucosamine, MB EnzymePro (DigeZyme Multi-Enzyme Complex)',
    supplementFacts: [
      { label: 'Serving Size', value: '3 Tablets (1 Sachet)' },
      { label: 'Vitamins Blend', value: 'A, C, D3, E, K2, B-Complex' },
      { label: 'Minerals Blend', value: 'Zinc, Magnesium, Calcium, Iron, Selenium' },
      { label: 'Joint Support Blend', value: 'Glucosamine, Boswellia' },
      { label: 'Testosterone Booster Blend', value: 'Ashwagandha, Fenugreek' },
      { label: 'MB EnzymePro', value: 'DigeZyme Complex' },
    ],
  },
  {
    id: 46,
    slug: 'muscleblaze-bcaa-pro-watermelon',
    name: 'MuscleBlaze BCAA Pro - Watermelon',
    category: 'preworkout',
    brand: 'MuscleBlaze',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/aoeweecg_IMG_5399.webp',
    description: '7g BCAAs, 1168mg Electrolytes & 2.5g L-Glutamine - Powerful Intra-Workout, Watermelon flavour, 450g',
    longDescription: 'MuscleBlaze BCAA Pro is a powerful intra-workout supplement designed to fuel your muscles during intense training sessions. Each serving delivers 7g of BCAAs (Branched-Chain Amino Acids) in the optimal 2:1:1 ratio to prevent muscle breakdown and promote recovery. With 1168mg of electrolytes to maintain hydration and 2.5g of L-Glutamine for immune support and muscle recovery, this formula covers all aspects of intra-workout nutrition. The refreshing Watermelon flavour makes it a pleasure to sip throughout your workout. Perfect for endurance athletes, bodybuilders, and anyone pushing their limits in the gym.',
    features: ['7g BCAAs', '1168mg Electrolytes', '2.5g L-Glutamine'],
    popular: false,
    price: 1299,
    stock: 'In Stock',
    protein: '0g',
    calories: 20,
    servings: 30,
    sizes: ['450g'],
    flavors: ['Watermelon'],
    benefits: ['7g BCAAs in 2:1:1 ratio to prevent muscle breakdown', '1168mg Electrolytes for optimal hydration', '2.5g L-Glutamine for recovery and immune support', 'Powerful intra-workout formula', 'Refreshing Watermelon flavour'],
    bestFor: 'Intra-workout performance & recovery',
    ingredients: 'L-Leucine, L-Isoleucine, L-Valine, L-Glutamine, Electrolyte Blend (Sodium Chloride, Potassium Chloride, Calcium Citrate, Magnesium Citrate), Citric Acid, Natural & Artificial Watermelon Flavoring, Sucralose, Red Beet Juice Powder (Color)',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (15g)' },
      { label: 'BCAAs (2:1:1)', value: '7g' },
      { label: 'L-Leucine', value: '3.5g' },
      { label: 'L-Isoleucine', value: '1.75g' },
      { label: 'L-Valine', value: '1.75g' },
      { label: 'L-Glutamine', value: '2.5g' },
      { label: 'Electrolytes', value: '1168mg' },
    ],
  },
  {
    id: 47,
    slug: 'koshaveda-ashwagandha-af43',
    name: 'Koshaveda Ashwagandha AF-43 600mg',
    category: 'vitamins',
    brand: 'Koshaveda',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/kartf4tj_IMG_5398.webp',
    description: '5X More Potent Ashwagandha AF-43 formula - Ayurveda for Performance, 600mg, 30 capsules',
    longDescription: 'Koshaveda Ashwagandha AF-43 is a premium Ayurvedic supplement formulated for performance-driven individuals. Featuring the proprietary AF-43 extract at 600mg per capsule, this formula is 5X more potent than standard ashwagandha supplements. Ashwagandha is one of the most powerful adaptogens in Ayurvedic medicine, known for its ability to help the body manage stress, improve sleep quality, and support strength and recovery. Whether you are an athlete looking for better recovery, a professional managing daily stress, or someone seeking improved sleep quality, this supplement delivers the ancient wisdom of Ayurveda in a modern, concentrated form.',
    features: ['5X More Potent', '600mg AF-43', 'Ayurvedic'],
    popular: false,
    price: 899,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 30,
    sizes: ['30 Capsules'],
    flavors: ['Unflavored'],
    benefits: ['5X more potent proprietary AF-43 ashwagandha extract', 'Promotes sound and restful sleep', 'Reduces stress and anxiety naturally', 'Supports strength and muscle recovery', 'All Ayurvedic, performance-focused formula'],
    bestFor: 'Stress relief, sleep & recovery',
    ingredients: 'Ashwagandha Root Extract (Withania Somnifera) AF-43 (600mg), Vegetable Cellulose Capsule, Rice Flour, Magnesium Stearate',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Capsule' },
      { label: 'Ashwagandha AF-43 Extract', value: '600mg' },
      { label: 'Withanolides', value: '5%' },
      { label: 'Capsules Per Container', value: '30' },
    ],
  },
  {
    id: 48,
    slug: 'kevin-levrone-gold-whey-chocolate',
    name: 'Kevin Levrone Gold Whey - Chocolate',
    category: 'whey',
    brand: 'Kevin Levrone',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/kejs2fab_IMG_5397.png',
    description: '25g protein, 6.2g BCAAs per serving - 100% Whey Concentrate, Signature Series Gold Line, 2kg',
    longDescription: 'Kevin Levrone Gold Whey is part of the legendary bodybuilder\'s Signature Series Gold Line. This 100% whey protein concentrate delivers 25g of high-quality protein and 6.2g of BCAAs per serving, making it an excellent choice for muscle building and recovery. Crafted to meet the standards of one of bodybuilding\'s greatest icons, this chocolate-flavoured protein powder mixes smoothly and tastes great. The 2kg tub provides exceptional value for serious athletes who demand premium quality protein to fuel their training and support muscle growth.',
    features: ['25g Protein', '6.2g BCAAs', '100% Whey Concentrate'],
    popular: true,
    price: 4499,
    stock: 'In Stock',
    protein: '25g',
    calories: 130,
    servings: 57,
    sizes: ['2kg'],
    flavors: ['Chocolate'],
    benefits: ['25g protein per serving for muscle building', '6.2g BCAAs for recovery and growth', '100% whey protein concentrate', 'Kevin Levrone Signature Series quality', 'Great tasting chocolate flavour'],
    bestFor: 'Muscle building & recovery',
    ingredients: 'Whey Protein Concentrate, Cocoa Powder, Natural & Artificial Chocolate Flavoring, Soy Lecithin (Emulsifier), Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (35g)' },
      { label: 'Calories', value: '130' },
      { label: 'Protein', value: '25g' },
      { label: 'BCAAs', value: '6.2g' },
      { label: 'Total Carbohydrate', value: '4g' },
      { label: 'Total Fat', value: '2g' },
    ],
  },
  {
    id: 49,
    slug: 'kevin-levrone-gold-iso-choco-oroi',
    name: 'Kevin Levrone Gold Iso - Choco-Oroi',
    category: 'whey',
    brand: 'Kevin Levrone',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/m2onwkc0_IMG_5396.png',
    description: '25g protein, 5.7g BCAAs per serving - 100% Whey Isolate, Signature Series Gold Line, 2kg',
    longDescription: 'Kevin Levrone Gold Iso is a premium 100% whey protein isolate from the Signature Series Gold Line. Each serving delivers 25g of pure, fast-absorbing whey protein isolate with 5.7g of BCAAs for optimal muscle growth and recovery. Whey isolate undergoes additional processing to remove most fat and lactose, making it a cleaner, leaner protein source ideal for those focused on building quality muscle without excess calories. The unique Choco-Oroi flavour offers a distinctive chocolate experience that stands out from standard protein powders. Backed by the legacy of Kevin Levrone, this is protein for serious athletes.',
    features: ['25g Protein', '5.7g BCAAs', '100% Whey Isolate'],
    popular: true,
    price: 5499,
    stock: 'In Stock',
    protein: '25g',
    calories: 110,
    servings: 57,
    sizes: ['2kg'],
    flavors: ['Choco-Oroi'],
    benefits: ['25g pure whey protein isolate per serving', '5.7g BCAAs for muscle recovery', '100% whey isolate - minimal fat and lactose', 'Supports lean muscle growth', 'Kevin Levrone Signature Series Gold Line quality'],
    bestFor: 'Lean muscle & clean protein intake',
    ingredients: 'Whey Protein Isolate, Cocoa Powder, Natural & Artificial Flavoring, Soy Lecithin (Emulsifier), Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (35g)' },
      { label: 'Calories', value: '110' },
      { label: 'Protein', value: '25g' },
      { label: 'BCAAs', value: '5.7g' },
      { label: 'Total Carbohydrate', value: '2g' },
      { label: 'Total Fat', value: '0.5g' },
    ],
  },
  {
    id: 50,
    slug: 'kevin-levrone-gold-creatine',
    name: 'Kevin Levrone Gold Creatine - Unflavoured',
    category: 'creatine',
    brand: 'Kevin Levrone',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/c3dspjis_IMG_5394.png',
    description: 'Pure creatine for maximized strength & minimized fatigue - Signature Series Gold Line, Unflavoured, 300g',
    longDescription: 'Kevin Levrone Gold Creatine is a premium creatine supplement from the Signature Series Gold Line. Designed to maximize physical strength and minimize tiredness and fatigue, this unflavoured creatine powder is perfect for stacking with your favourite pre-workout, protein shake, or any other supplement. Creatine is one of the most researched and proven sports supplements in the world, known for its ability to increase ATP production, enhance explosive power, and support muscle volumization. The unflavoured formula ensures maximum versatility, allowing you to add it to any beverage without altering the taste.',
    features: ['Maximized Strength', 'Minimized Fatigue', 'Unflavoured'],
    popular: false,
    price: 1599,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 60,
    sizes: ['300g'],
    flavors: ['Unflavoured'],
    benefits: ['Maximizes physical strength and power', 'Minimizes tiredness and fatigue', 'Unflavoured for easy mixing and stacking', 'Kevin Levrone Signature Series quality', 'Supports muscle volumization and ATP production'],
    bestFor: 'Strength, power & endurance',
    ingredients: 'Creatine Monohydrate',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (5g)' },
      { label: 'Creatine Monohydrate', value: '5g' },
      { label: 'Calories', value: '0' },
      { label: 'Servings Per Container', value: '60' },
    ],
  },
  {
    id: 51,
    slug: 'gnc-pro-performance-creatine-monohydrate',
    name: 'GNC Pro Performance Creatine Monohydrate',
    category: 'creatine',
    brand: 'GNC',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/lh70xkbs_IMG_5393.webp',
    description: 'Micronized creatine, 3g per scoop - Helps improve muscle building, strength & athletic performance, 250g',
    longDescription: 'GNC Pro Performance Creatine Monohydrate is a trusted creatine supplement from one of the world\'s most recognized supplement brands, trusted since 1988. This micronized creatine powder delivers 3g of pure creatine monohydrate per scoop, designed to help improve muscle building, strength, and overall athletic performance. The micronized formula ensures it mixes easily with water or your favourite beverage without clumping. Unflavoured and versatile, it can be added to any pre-workout, protein shake, or simply mixed with water. Backed by GNC\'s Pro Performance line, this is a reliable daily creatine supplement for athletes at every level.',
    features: ['3g Creatine/Scoop', 'Micronized', 'Trusted Since 1988'],
    popular: false,
    price: 999,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 83,
    sizes: ['250g'],
    flavors: ['Unflavoured'],
    benefits: ['Micronized for easy mixing without clumps', 'Helps improve muscle building and strength', 'Enhances athletic performance', 'GNC Pro Performance trusted quality since 1988', 'Unflavoured - versatile for any beverage'],
    bestFor: 'Muscle building & athletic performance',
    ingredients: 'Creatine Monohydrate (Micronized)',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (3g)' },
      { label: 'Creatine Monohydrate', value: '3g' },
      { label: 'Calories', value: '0' },
      { label: 'Servings Per Container', value: '83' },
    ],
  },
  {
    id: 52,
    slug: 'bigmuscles-karnage-pre-workout',
    name: 'Big Muscles Karnage Pre-Workout - Sex on the Beach',
    category: 'preworkout',
    brand: 'Big Muscles Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/yi0ag467_IMG_5375.webp',
    description: 'King of Pre-Workouts - explosive energy, focus & pumps, Sex on the Beach (Fruit Punch) flavour, 300g',
    longDescription: 'Big Muscles Nutrition Karnage is marketed as the King of Pre-Workouts, and it lives up to its aggressive name. This powerful pre-workout formula is designed to deliver explosive energy, razor-sharp focus, and skin-splitting pumps during your most intense training sessions. The Sex on the Beach (Fruit Punch) flavour makes it a refreshing and enjoyable pre-workout drink. Formulated with a potent blend of performance-enhancing ingredients, Karnage is built for athletes who train at maximum intensity and refuse to hold back. Vegetarian-friendly and available in a 300g tub.',
    features: ['King of Pre-Workouts', 'Explosive Energy', 'Fruit Punch Flavour'],
    popular: false,
    price: 1499,
    stock: 'In Stock',
    protein: '0g',
    calories: 15,
    servings: 30,
    sizes: ['300g'],
    flavors: ['Sex on the Beach (Fruit Punch)'],
    benefits: ['Explosive energy for intense workouts', 'Enhanced mental focus and concentration', 'Powerful muscle pumps and vascularity', 'Delays fatigue for longer training sessions', 'Vegetarian-friendly formula'],
    bestFor: 'Intense pre-workout energy & pumps',
    ingredients: 'Beta-Alanine, Citrulline Malate, Caffeine Anhydrous, L-Arginine, Taurine, Niacin, Citric Acid, Natural & Artificial Flavoring, Sucralose, Silicon Dioxide',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (10g)' },
      { label: 'Beta-Alanine', value: '3.2g' },
      { label: 'Citrulline Malate', value: '3g' },
      { label: 'Caffeine', value: '200mg' },
      { label: 'L-Arginine', value: '1g' },
      { label: 'Taurine', value: '500mg' },
    ],
  },
  {
    id: 53,
    slug: 'bigmuscles-karnage-black-pre-workout',
    name: 'Big Muscles Karnage Black Pre-Workout - Sex on the Beach',
    category: 'preworkout',
    brand: 'Big Muscles Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/rxsoy4l2_IMG_5374.jpeg',
    description: 'The End of Pre-Workouts - extreme energy & performance, Sex on the Beach (Fruit Punch) flavour, 420g',
    longDescription: 'Big Muscles Nutrition Karnage Black takes pre-workout intensity to the next level. Billed as "The End of Pre-Workouts," this hardcore formula is designed for experienced athletes who need maximum stimulation and performance enhancement. With a larger 420g tub and a more potent formulation than the standard Karnage, the Black edition delivers extreme energy, unmatched focus, and relentless endurance. The Sex on the Beach (Fruit Punch) flavour keeps it refreshing despite the hardcore nature. This is not for beginners - Karnage Black is built for those who push beyond their limits every single session.',
    features: ['End of Pre-Workouts', 'Extreme Energy', '420g Tub'],
    popular: true,
    price: 1999,
    stock: 'In Stock',
    protein: '0g',
    calories: 20,
    servings: 30,
    sizes: ['420g'],
    flavors: ['Sex on the Beach (Fruit Punch)'],
    benefits: ['Extreme energy for the most intense workouts', 'Unmatched mental focus and drive', 'Enhanced endurance and stamina', 'Powerful pumps and vasodilation', 'Larger 420g tub for serious athletes'],
    bestFor: 'Hardcore pre-workout performance',
    ingredients: 'Beta-Alanine, Citrulline Malate, Caffeine Anhydrous, L-Arginine Alpha-Ketoglutarate, Taurine, L-Tyrosine, Niacin, BioPerine, Citric Acid, Natural & Artificial Flavoring, Sucralose',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (14g)' },
      { label: 'Beta-Alanine', value: '3.5g' },
      { label: 'Citrulline Malate', value: '4g' },
      { label: 'Caffeine', value: '300mg' },
      { label: 'L-Arginine AKG', value: '1.5g' },
      { label: 'L-Tyrosine', value: '500mg' },
      { label: 'BioPerine', value: '5mg' },
    ],
  },
  {
    id: 54,
    slug: 'bigmuscles-body-fuel-hardcore-chocolate-eclair',
    name: 'Big Muscles Body Fuel Hardcore - Chocolate Eclair',
    category: 'massgainer',
    brand: 'Big Muscles Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/1gnt9a1w_IMG_5376.jpeg',
    description: '40g protein, 3g creatine, 140g carbs per serving - ProHydrolase Enzyme Technology, 3kg',
    longDescription: 'Big Muscles Nutrition Body Fuel Hardcore is a high-protein and high-carb mass gainer designed for serious weight gain and muscle building. Each massive serving delivers 40g of protein for muscle repair and growth, 3g of creatine for increased power output, and 140g of carbs to fuel intense workouts and create the caloric surplus needed for mass gain. Powered by ProHydrolase Enzyme Technology for enhanced protein digestion and absorption, and formulated with international ingredients for premium quality. The Chocolate Eclair flavour turns your mass gainer shake into a dessert-like experience. Available in a 3kg (6.6lb) tub for long-lasting supply.',
    features: ['40g Protein', '3g Creatine', '140g Carbs'],
    popular: true,
    price: 2999,
    stock: 'In Stock',
    protein: '40g',
    calories: 750,
    servings: 14,
    sizes: ['3kg (6.6lb)'],
    flavors: ['Chocolate Eclair'],
    benefits: ['40g protein for muscle repair and growth', '3g creatine for increased power output', '140g carbs for caloric surplus and energy', 'ProHydrolase Enzyme Technology for better absorption', 'International quality ingredients'],
    bestFor: 'Mass gain & muscle building',
    ingredients: 'Maltodextrin, Whey Protein Concentrate, Whey Protein Isolate, Cocoa Powder, Creatine Monohydrate, ProHydrolase (Digestive Enzyme Blend), Natural & Artificial Flavoring, Soy Lecithin, Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '3 Scoops (approx. 200g)' },
      { label: 'Calories', value: '750' },
      { label: 'Protein', value: '40g' },
      { label: 'Total Carbohydrate', value: '140g' },
      { label: 'Creatine', value: '3g' },
      { label: 'Total Fat', value: '4g' },
    ],
  },
  {
    id: 55,
    slug: 'bigmuscles-nitric-whey-protein-rich-chocolate',
    name: 'Big Muscles Nitric Whey Protein - Rich Chocolate',
    category: 'whey',
    brand: 'Big Muscles Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/v9yr6ue3_IMG_5382.webp',
    description: '27g protein, 12g EAA, 4.4g glutamine per serving - Whey Isolate with ProHydrolase, Rich Chocolate, 1kg',
    longDescription: 'Big Muscles Nutrition Nitric Whey Protein uses whey protein isolate as its primary source, delivering 27g of high-quality protein per serving for lean muscle development and recovery. Each serving also packs 12g of Essential Amino Acids (EAAs) and 4.4g of glutamine to support muscle repair, immune function, and overall recovery. Designed with ProHydrolase Enzyme Technology for maximized protein absorption and minimal digestive discomfort, and formulated with international ingredients for premium quality. The Rich Chocolate flavour makes every shake a treat. Available in a 1kg (2.2lb) tub.',
    features: ['27g Protein', '12g EAA', 'ProHydrolase'],
    popular: true,
    price: 2499,
    stock: 'In Stock',
    protein: '27g',
    calories: 120,
    servings: 28,
    sizes: ['1kg (2.2lb)'],
    flavors: ['Rich Chocolate'],
    benefits: ['27g whey protein isolate per serving', '12g Essential Amino Acids for complete recovery', '4.4g glutamine for immune and muscle support', 'ProHydrolase Enzyme Technology for maximum absorption', 'International quality ingredients'],
    bestFor: 'Lean muscle & recovery',
    ingredients: 'Whey Protein Isolate, Whey Protein Concentrate, Cocoa Powder, ProHydrolase (Digestive Enzyme Blend), L-Glutamine, Natural & Artificial Chocolate Flavoring, Soy Lecithin, Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (35g)' },
      { label: 'Calories', value: '120' },
      { label: 'Protein', value: '27g' },
      { label: 'EAA', value: '12g' },
      { label: 'Glutamine', value: '4.4g' },
      { label: 'Total Carbohydrate', value: '3g' },
      { label: 'Total Fat', value: '1.5g' },
    ],
  },
  {
    id: 56,
    slug: 'm-wellness-salmon-fish-oil',
    name: 'M Wellness Salmon Fish Oil 1000mg',
    category: 'vitamins',
    brand: 'M Wellness',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/qit4ri7p_IMG_5383.webp',
    description: 'Premium Omega-3, 1000mg Fish Oil with 180mg EPA & 120mg DHA - Healthy heart, joints & muscle recovery, 60 softgels',
    longDescription: 'M Wellness Salmon Fish Oil provides premium quality omega-3 fatty acids sourced from salmon. Each 1000mg softgel delivers 180mg EPA and 120mg DHA, the two most important omega-3 fatty acids for overall health. This supplement supports healthy heart function, promotes joint health and flexibility, and helps reduce muscle soreness after intense workouts. The softgel form ensures easy swallowing and better absorption compared to tablets. With "Health Before Everything" as their motto, M Wellness delivers a reliable daily omega-3 supplement for athletes and health-conscious individuals. 60 softgels per bottle for a 2-month supply.',
    features: ['1000mg Fish Oil', '180mg EPA', '120mg DHA'],
    popular: false,
    price: 599,
    stock: 'In Stock',
    protein: '0g',
    calories: 10,
    servings: 60,
    sizes: ['60 Softgels'],
    flavors: ['Unflavored'],
    benefits: ['Supports healthy heart function', 'Promotes healthy joints and flexibility', 'Reduces muscle soreness after workouts', 'Premium quality omega-3 from salmon', 'Easy-to-swallow softgel capsules'],
    bestFor: 'Heart health, joints & recovery',
    ingredients: 'Salmon Fish Oil, EPA (Eicosapentaenoic Acid), DHA (Docosahexaenoic Acid), Gelatin, Glycerin, Purified Water',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Softgel' },
      { label: 'Fish Oil', value: '1000mg' },
      { label: 'EPA', value: '180mg' },
      { label: 'DHA', value: '120mg' },
      { label: 'Total Omega-3', value: '300mg' },
    ],
  },
  {
    id: 57,
    slug: 'bm-wellness-true-vitamin',
    name: 'BM Wellness True Vitamin - Probiotic Multivitamin',
    category: 'vitamins',
    brand: 'BM Wellness',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/4oi987y4_IMG_5384.jpeg',
    description: 'Complete Probiotic Multi Vitamins & Minerals formula - Supports overall health, energy, gut health & immunity, 60 tablets',
    longDescription: 'BM Wellness True Vitamin is a complete probiotic multivitamin and minerals formula designed for adults who want comprehensive daily nutrition. This all-in-one supplement combines essential vitamins and minerals with probiotics to support overall health, build sustained energy levels, and promote gut health and immunity. The inclusion of probiotics sets it apart from standard multivitamins by addressing digestive wellness as a foundation for overall health. With 60 tablets per bottle providing a full 2-month supply, True Vitamin is a convenient and affordable way to fill nutritional gaps in your diet.',
    features: ['Probiotic Formula', 'Multi Vitamins & Minerals', 'Gut Health & Immunity'],
    popular: false,
    price: 499,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 60,
    sizes: ['60 Tablets'],
    flavors: ['Unflavored'],
    benefits: ['Complete multivitamin and mineral formula', 'Probiotics for gut health and digestion', 'Supports overall health and immunity', 'Builds sustained energy levels', '60 tablets for a 2-month supply'],
    bestFor: 'Daily nutrition & gut health',
    ingredients: 'Vitamin A, Vitamin C, Vitamin D3, Vitamin E, B-Complex Vitamins (B1, B2, B3, B5, B6, B7, B9, B12), Zinc, Iron, Calcium, Magnesium, Selenium, Probiotic Blend (Lactobacillus Acidophilus, Bifidobacterium Lactis)',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Tablet' },
      { label: 'Vitamins Blend', value: 'A, C, D3, E, B-Complex' },
      { label: 'Minerals Blend', value: 'Zinc, Iron, Calcium, Magnesium, Selenium' },
      { label: 'Probiotic Blend', value: '2 Billion CFU' },
      { label: 'Tablets Per Container', value: '60' },
    ],
  },
  {
    id: 58,
    slug: 'bigmuscles-zero-whey-isolate-rich-chocolate',
    name: 'Big Muscles Zero 100% Whey Isolate - Rich Chocolate',
    category: 'whey',
    brand: 'Big Muscles Nutrition',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/afnd2udt_IMG_5385.webp',
    description: '29g protein, 0g sugar, 12g EAA & 4.4g glutamine per serving - 100% Whey Isolate with ProHydrolase, 2kg',
    longDescription: 'Big Muscles Nutrition Zero 100% Whey Isolate delivers a clean, premium protein experience with absolutely zero sugar per serving. Each scoop provides 29g of pure whey protein isolate, 12g of Essential Amino Acids (EAAs), and 4.4g of glutamine for complete muscle recovery and growth. The Zero sugar formula makes it ideal for athletes on cutting phases or those watching their carbohydrate intake. Enhanced with ProHydrolase Enzyme Technology for superior protein digestion and absorption, and formulated with international ingredients. The Rich Chocolate flavour delivers a decadent taste without the guilt. Available in a large 2kg (4.4lb) tub.',
    features: ['29g Protein', '0g Sugar', '12g EAA'],
    popular: true,
    price: 4999,
    stock: 'In Stock',
    protein: '29g',
    calories: 115,
    servings: 57,
    sizes: ['2kg (4.4lb)'],
    flavors: ['Rich Chocolate'],
    benefits: ['29g pure whey protein isolate per serving', 'Zero sugar for clean nutrition', '12g EAAs for complete muscle recovery', '4.4g glutamine for immune support', 'ProHydrolase Enzyme Technology for better absorption'],
    bestFor: 'Clean protein & lean muscle',
    ingredients: 'Whey Protein Isolate, Cocoa Powder, ProHydrolase (Digestive Enzyme Blend), L-Glutamine, Natural & Artificial Chocolate Flavoring, Soy Lecithin, Sucralose, Acesulfame Potassium',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (35g)' },
      { label: 'Calories', value: '115' },
      { label: 'Protein', value: '29g' },
      { label: 'Sugar', value: '0g' },
      { label: 'EAA', value: '12g' },
      { label: 'Glutamine', value: '4.4g' },
      { label: 'Total Fat', value: '1g' },
    ],
  },
  {
    id: 59,
    slug: 'dexter-jackson-testo-gold',
    name: 'Dexter Jackson Testo Gold',
    category: 'vitamins',
    brand: 'Dexter Jackson',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/p0cm7c4c_IMG_5386.webp',
    description: 'Muscle & Male Performance - Supports endurance, strength, lean body mass & training, 60 tablets (30 days)',
    longDescription: 'Dexter Jackson Signature Series Testo Gold is a nutraceutical supplement specifically formulated for male performance and muscle building. Named after the legendary IFBB Pro bodybuilder, this product naturally supports male performance, endurance and strength, lean body mass development, and enhanced training capacity. With 60 tablets providing a full 30-day supply at 2 tablets per day, Testo Gold is designed for serious male athletes looking to optimize their performance naturally. The Dexter Jackson Signature Series carries the legacy of one of bodybuilding\'s greatest champions.',
    features: ['Male Performance', 'Endurance & Strength', 'Lean Body Mass'],
    popular: false,
    price: 1299,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 30,
    sizes: ['60 Tablets (30 Days)'],
    flavors: ['Unflavored'],
    benefits: ['Naturally supports male performance', 'Enhances endurance and strength', 'Supports lean body mass development', 'Improves training capacity and output', 'Dexter Jackson Signature Series quality'],
    bestFor: 'Male performance & strength',
    ingredients: 'Tribulus Terrestris Extract, Fenugreek Extract, D-Aspartic Acid, Zinc, Vitamin D3, Vitamin B6, Microcrystalline Cellulose, Dicalcium Phosphate, Magnesium Stearate, Silicon Dioxide',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Tablets' },
      { label: 'Tribulus Terrestris', value: '500mg' },
      { label: 'Fenugreek Extract', value: '300mg' },
      { label: 'D-Aspartic Acid', value: '250mg' },
      { label: 'Zinc', value: '15mg' },
      { label: 'Vitamin D3', value: '1000 IU' },
    ],
  },
  {
    id: 60,
    slug: 'carbamide-forte-marine-collagen-watermelon',
    name: 'Carbamide Forte Marine Collagen - Watermelon',
    category: 'vitamins',
    brand: 'Carbamide Forte',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/c2hstbsr_IMG_5387.webp',
    description: 'Type 1 Hydrolyzed Fish Collagen with Hyaluronic Acid, Vitamin C, Biotin & Vitamin E - Watermelon flavour, 200g',
    longDescription: 'Carbamide Forte Marine Collagen is a premium skin health supplement featuring Type 1 hydrolyzed fish collagen in a delicious watermelon flavour powder. This advanced formula combines marine collagen with Hyaluronic Acid for skin hydration, Vitamin C for collagen synthesis, Biotin for hair and nail strength, and Vitamin E for antioxidant protection. Type 1 collagen is the most abundant type in the human body and is essential for maintaining skin elasticity, firmness, and a youthful appearance. The watermelon flavour makes it a refreshing daily drink that supports your beauty from within. Simply mix with water for a tasty collagen boost.',
    features: ['Type 1 Collagen', 'Hyaluronic Acid', 'Biotin & Vitamin C'],
    popular: false,
    price: 999,
    stock: 'In Stock',
    protein: '0g',
    calories: 15,
    servings: 20,
    sizes: ['200g'],
    flavors: ['Watermelon'],
    benefits: ['Type 1 hydrolyzed fish collagen for skin elasticity', 'Hyaluronic Acid for deep skin hydration', 'Vitamin C supports natural collagen synthesis', 'Biotin for stronger hair and nails', 'Vitamin E for antioxidant protection'],
    bestFor: 'Skin health, hair & nails',
    ingredients: 'Hydrolyzed Fish Collagen (Type 1), Hyaluronic Acid, Vitamin C (Ascorbic Acid), Biotin, Vitamin E (DL-Alpha Tocopheryl Acetate), Citric Acid, Natural Watermelon Flavoring, Sucralose, Silicon Dioxide',
    supplementFacts: [
      { label: 'Serving Size', value: '1 Scoop (10g)' },
      { label: 'Marine Collagen (Type 1)', value: '5000mg' },
      { label: 'Hyaluronic Acid', value: '50mg' },
      { label: 'Vitamin C', value: '40mg' },
      { label: 'Biotin', value: '30mcg' },
      { label: 'Vitamin E', value: '10mg' },
    ],
  },
  {
    id: 61,
    slug: 'carbamide-forte-magnesium-glycinate',
    name: 'Carbamide Forte Chelated Magnesium Glycinate 2000mg',
    category: 'vitamins',
    brand: 'Carbamide Forte',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/8fzr2b4t_IMG_5388.webp',
    description: '2000mg Chelated Magnesium Glycinate - Supports muscle recovery & relaxation, 100% RDA, 120 tablets for men',
    longDescription: 'Carbamide Forte Maginova Chelated Magnesium Glycinate delivers 2000mg of highly bioavailable chelated magnesium glycinate per serving. Magnesium glycinate is one of the most absorbable forms of magnesium, making it significantly more effective than standard magnesium oxide or citrate supplements. This formulation supports muscle recovery after intense workouts, promotes relaxation and stress relief, and provides 100% of the Recommended Daily Allowance (RDA) for magnesium. Specifically formulated for men, this supplement addresses the common magnesium deficiency that can affect athletic performance, sleep quality, and muscle function. 120 tablets per bottle for a long-lasting supply.',
    features: ['2000mg Magnesium', 'Chelated Glycinate', '100% RDA'],
    popular: false,
    price: 699,
    stock: 'In Stock',
    protein: '0g',
    calories: 0,
    servings: 60,
    sizes: ['120 Tablets'],
    flavors: ['Unflavored'],
    benefits: ['2000mg highly bioavailable chelated magnesium', 'Supports muscle recovery and reduces cramps', 'Promotes relaxation and better sleep', '100% RDA of magnesium per serving', 'Superior absorption vs standard magnesium forms'],
    bestFor: 'Muscle recovery & relaxation',
    ingredients: 'Magnesium Glycinate (Chelated), Microcrystalline Cellulose, Dicalcium Phosphate, Croscarmellose Sodium, Magnesium Stearate, Silicon Dioxide, Film Coating',
    supplementFacts: [
      { label: 'Serving Size', value: '2 Tablets' },
      { label: 'Magnesium Glycinate', value: '2000mg' },
      { label: 'Elemental Magnesium', value: '240mg (100% RDA)' },
      { label: 'Tablets Per Container', value: '120' },
      { label: 'Servings Per Container', value: '60' },
    ],
  },
  {
    id: 62,
    slug: 'richroots-chocolate-peanut-butter',
    name: 'Richroots Chocolate Peanut Butter',
    category: 'accessories',
    brand: 'Richroots',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/ydiikp8m_Photoroom_20260318_041333.jpeg',
    description: 'Rich chocolate peanut butter - high protein, healthy fats, perfect for shakes & meals, available in 1kg & 500g',
    longDescription: 'Richroots Chocolate Peanut Butter combines the protein-rich goodness of premium peanuts with rich, indulgent chocolate for a spread that fuels your fitness and satisfies your taste buds. Packed with protein and healthy fats, this chocolate peanut butter is a favourite among athletes and gym-goers as a convenient source of clean calories and macronutrients. Add it to your protein shakes, spread it on toast, mix it into oatmeal, or eat it straight from the jar as a post-workout snack. With the Richroots commitment to health and nutrition, this is a delicious way to hit your daily protein and calorie targets.',
    features: ['High Protein', 'Healthy Fats', 'Chocolate Flavour'],
    popular: false,
    price: 399,
    stock: 'In Stock',
    protein: '25g per 100g',
    calories: 590,
    servings: 30,
    sizes: ['500g', '1kg'],
    flavors: ['Chocolate'],
    benefits: ['High protein content for muscle building', 'Healthy fats for sustained energy', 'Rich chocolate flavour for taste', 'Versatile - shakes, toast, oatmeal, baking', 'Clean calories for bulking diets'],
    bestFor: 'High-protein snacking & meals',
    ingredients: 'Roasted Peanuts, Cocoa Powder, Sugar, Salt, Peanut Oil, Emulsifier (Soy Lecithin)',
    supplementFacts: [
      { label: 'Serving Size', value: '32g (2 tablespoons)' },
      { label: 'Calories', value: '190' },
      { label: 'Protein', value: '8g' },
      { label: 'Total Fat', value: '16g' },
      { label: 'Total Carbohydrate', value: '6g' },
      { label: 'Sugar', value: '3g' },
    ],
  },
  {
    id: 63,
    slug: 'richroots-classic-peanut-butter',
    name: 'Richroots Classic Peanut Butter',
    category: 'accessories',
    brand: 'Richroots',
    image: 'https://customer-assets.emergentagent.com/job_2aea7b43-d51a-4405-a6b3-771800114f3e/artifacts/drgq31fd_2726B2A6-C4B2-4CA7-BAAD-24E7B91E043B.png',
    description: 'Classic peanut butter - high protein, natural healthy fats, perfect for athletes & fitness enthusiasts, available in 1kg & 500g',
    longDescription: 'Richroots Classic Peanut Butter is a staple in every athlete\'s kitchen. Made from premium roasted peanuts, this classic spread delivers high-quality protein and natural healthy fats in every spoonful. Whether you are bulking, cutting, or maintaining, peanut butter is one of the most versatile and nutrient-dense foods for fitness enthusiasts. Spread it on bread, blend it into your protein shakes, mix it with oatmeal, or use it in your high-protein recipes. Richroots focuses on health and nutrition, delivering a clean and natural peanut butter that tastes great and fuels your gains.',
    features: ['High Protein', 'Natural Healthy Fats', 'Classic Flavour'],
    popular: false,
    price: 349,
    stock: 'In Stock',
    protein: '26g per 100g',
    calories: 600,
    servings: 30,
    sizes: ['500g', '1kg'],
    flavors: ['Classic'],
    benefits: ['High protein from premium roasted peanuts', 'Natural healthy fats for sustained energy', 'Versatile for shakes, meals, and snacking', 'Clean and natural ingredients', 'Essential pantry staple for athletes'],
    bestFor: 'High-protein snacking & cooking',
    ingredients: 'Roasted Peanuts, Salt, Peanut Oil, Emulsifier (Soy Lecithin)',
    supplementFacts: [
      { label: 'Serving Size', value: '32g (2 tablespoons)' },
      { label: 'Calories', value: '192' },
      { label: 'Protein', value: '8.3g' },
      { label: 'Total Fat', value: '16g' },
      { label: 'Total Carbohydrate', value: '5g' },
      { label: 'Sugar', value: '1g' },
    ],
  },
];

export const categories = [
  { id: 'all', name: 'All Products' },
  { id: 'whey', name: 'Whey Protein' },
  { id: 'creatine', name: 'Creatine' },
  { id: 'preworkout', name: 'Pre-Workout' },
  { id: 'massgainer', name: 'Mass Gainers' },
  { id: 'fatburner', name: 'Fat Burners' },
  { id: 'vitamins', name: 'Vitamins & Health' },
  { id: 'accessories', name: 'Accessories' },
];
